import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { ScrollArea } from "@/components/ui/scroll-area";
import {
  DollarSign,
  TrendingUp,
  TrendingDown,
  Wallet,
  CreditCard,
  Users,
  FileText,
  Plus,
  Search,
  Filter,
  Download,
  Calendar,
  ArrowUpRight,
  ArrowDownLeft,
  BarChart3,
  PieChart,
  Receipt,
  Banknote,
  CircleDollarSign,
  CheckCircle,
  Clock,
  AlertCircle,
  XCircle,
  Building2,
  Eye,
  Pencil,
  Trash2,
  RotateCcw,
  MinusCircle,
  Upload,
  FileSpreadsheet,
  ChevronDown
} from "lucide-react";

const formatCurrency = (value) => {
  if (!value && value !== 0) return "R$ 0,00";
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  }).format(value);
};

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  try {
    return new Date(dateStr).toLocaleDateString("pt-BR");
  } catch {
    return dateStr;
  }
};

export default function Financeiro() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("lancamentos");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [periodoFiltro, setPeriodoFiltro] = useState("mes");
  
  // Usuário logado
  const [usuarioLogado, setUsuarioLogado] = useState(null);
  
  // Filtros da tabela Pendentes de Recebimento
  const [filtroBanco, setFiltroBanco] = useState("todos");
  const [filtroCorrespondente, setFiltroCorrespondente] = useState("todos");
  const [filtroTipoOperacao, setFiltroTipoOperacao] = useState("todos");
  const [buscaComissao, setBuscaComissao] = useState("");
  
  // Gestão de Contas states
  const [gestaoContas, setGestaoContas] = useState([]);
  const [gestaoLancamentos, setGestaoLancamentos] = useState([]);
  const [gestaoSaldo, setGestaoSaldo] = useState({ contas: [], totais: { total_creditos: 0, total_debitos: 0, saldo_geral: 0 } });
  const [showNovoLancamento, setShowNovoLancamento] = useState(false);
  const [showNovaConta, setShowNovaConta] = useState(false);
  const [showEstorno, setShowEstorno] = useState(null);
  const [showBaixa, setShowBaixa] = useState(null);
  const [showDespesasDetalhe, setShowDespesasDetalhe] = useState(false);
  const [estornoMotivo, setEstornoMotivo] = useState("");
  const [baixaData, setBaixaData] = useState({ data_baixa: new Date().toISOString().split('T')[0], forma_pagamento: "", observacao: "" });
  const [formaPgtoLanc, setFormaPgtoLanc] = useState({});
  const [novoLancamento, setNovoLancamento] = useState({
    data: new Date().toISOString().split('T')[0], tipo: "CREDITO", descricao: "", valor: "", conta_id: "", categoria: "", centro_custo: "", observacao: "", tipo_cobranca: "unica", parcelas: 1, baixar_auto: false
  });
  const [novaConta, setNovaConta] = useState({ nome: "", tipo: "ATIVO", categoria: "", saldo_inicial: "0" });
  const [categoriasGestao, setCategoriasGestao] = useState([]);
  const [novaCategoriaNome, setNovaCategoriaNome] = useState("");
  const [filtroMesLanc, setFiltroMesLanc] = useState(String(new Date().getMonth() + 1));
  const [filtroAnoLanc, setFiltroAnoLanc] = useState(String(new Date().getFullYear()));
  const [filtroStatusLanc, setFiltroStatusLanc] = useState("todos");
  const [filtroTipoLanc, setFiltroTipoLanc] = useState("todos");
  const [filtroContaLanc, setFiltroContaLanc] = useState("todos");
  const [filtroCategoriaLanc, setFiltroCategoriaLanc] = useState("todos");
  const [valorPagoEdits, setValorPagoEdits] = useState({});

  // Data states
  const [resumo, setResumo] = useState({
    receita_total: 0,
    despesa_total: 0,
    saldo: 0,
    comissoes_pendentes: 0,
    comissoes_pagas: 0,
    contratos_mes: 0,
    ticket_medio: 0
  });
  const [comissoes, setComissoes] = useState([]);
  const [transacoes, setTransacoes] = useState([]);
  const [fluxoCaixa, setFluxoCaixa] = useState([]);
  const [debitos, setDebitos] = useState([]);
  const [debitosResumo, setDebitosResumo] = useState({ total_pendente: 0, total_processado: 0 });
  
  // Modal states
  const [showNovaTransacao, setShowNovaTransacao] = useState(false);
  const [showNovaComissao, setShowNovaComissao] = useState(false);
  const [showImportarRelatorioBanco, setShowImportarRelatorioBanco] = useState(false);
  const [expandedOperadores, setExpandedOperadores] = useState({});
  const [tipoTransacao, setTipoTransacao] = useState("RECEITA");
  
  // Estado para importação de relatório do banco
  const [importRelatorioFile, setImportRelatorioFile] = useState(null);
  const [importRelatorioBanco, setImportRelatorioBanco] = useState("");
  const [importRelatorioLoading, setImportRelatorioLoading] = useState(false);
  const [importRelatorioPreview, setImportRelatorioPreview] = useState(null);
  const [importRelatorioFormato, setImportRelatorioFormato] = useState("padrao");
  const [importRelatorioResultado, setImportRelatorioResultado] = useState(null);
  
  // Form states
  const [novaTransacao, setNovaTransacao] = useState({
    tipo: "RECEITA",
    categoria: "",
    descricao: "",
    valor: "",
    data: new Date().toISOString().split('T')[0],
    status: "PENDENTE",
    cliente_id: "",
    contrato_id: "",
    observacao: ""
  });

  // Função para gerar PDF de Comissões Pagas
  const gerarPDFComissoesPagas = () => {
    const comissoesPagas = comissoes.filter(c => c.status === "PAGO");
    
    if (comissoesPagas.length === 0) {
      toast.error("Não há comissões pagas para gerar relatório");
      return;
    }
    
    // Calcular totais
    const totalRecebidoEmpresa = comissoesPagas.reduce((acc, c) => acc + (c.valor_recebido || c.valor_empresa || 0), 0);
    const totalPagoOperadores = comissoesPagas.reduce((acc, c) => {
      const base = c.valor_recebido || c.valor_empresa || 0;
      const isAtendente = (c.perfil_operador || "ATENDENTE").toUpperCase() === "ATENDENTE";
      const isCorretor = (c.perfil_operador || "").toUpperCase() === "CORRETOR";
      return acc + (isAtendente ? (base * (c.percentual_atendente || 5)) / 100 : isCorretor ? (base * (c.percentual_corretor || 30)) / 100 : 0);
    }, 0);
    const totalPagoGerAdm = comissoesPagas.reduce((acc, c) => {
      const base = c.valor_recebido || c.valor_empresa || 0;
      return acc + (base * (c.percentual_ger_adm || 10)) / 100;
    }, 0);
    const totalImpostos = comissoesPagas.reduce((acc, c) => {
      const base = c.valor_recebido || c.valor_empresa || 0;
      return acc + (base * (c.percentual_imposto || 15)) / 100;
    }, 0);
    const lucroLiquidoTotal = totalRecebidoEmpresa - totalPagoOperadores - totalPagoGerAdm - totalImpostos;
    
    // Criar PDF
    const doc = new jsPDF();
    const dataAtual = new Date().toLocaleDateString("pt-BR");
    
    // Header
    doc.setFontSize(18);
    doc.setTextColor(34, 139, 34);
    doc.text("RELATÓRIO DE COMISSÕES PAGAS", 105, 20, { align: "center" });
    
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text(`Data de Emissão: ${dataAtual}`, 105, 28, { align: "center" });
    
    // Resumo da Empresa
    doc.setFontSize(14);
    doc.setTextColor(0, 100, 0);
    doc.text("RESUMO DA EMPRESA", 14, 42);
    
    doc.setDrawColor(34, 139, 34);
    doc.setLineWidth(0.5);
    doc.line(14, 44, 196, 44);
    
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    const summaryStartY = 52;
    const col1 = 14;
    const col2 = 110;
    
    doc.text(`Total Recebido (Banco):`, col1, summaryStartY);
    doc.setTextColor(34, 139, 34);
    doc.setFont(undefined, "bold");
    doc.text(formatCurrency(totalRecebidoEmpresa), col1 + 45, summaryStartY);
    
    doc.setFont(undefined, "normal");
    doc.setTextColor(60, 60, 60);
    doc.text(`Pago Operadores:`, col2, summaryStartY);
    doc.setTextColor(255, 140, 0);
    doc.setFont(undefined, "bold");
    doc.text(formatCurrency(totalPagoOperadores), col2 + 35, summaryStartY);
    
    doc.setFont(undefined, "normal");
    doc.setTextColor(60, 60, 60);
    doc.text(`Pago Ger. Adm:`, col1, summaryStartY + 8);
    doc.setTextColor(128, 0, 128);
    doc.setFont(undefined, "bold");
    doc.text(formatCurrency(totalPagoGerAdm), col1 + 35, summaryStartY + 8);
    
    doc.setFont(undefined, "normal");
    doc.setTextColor(60, 60, 60);
    doc.text(`Impostos:`, col2, summaryStartY + 8);
    doc.setTextColor(220, 20, 60);
    doc.setFont(undefined, "bold");
    doc.text(formatCurrency(totalImpostos), col2 + 20, summaryStartY + 8);
    
    doc.setFont(undefined, "normal");
    doc.setTextColor(60, 60, 60);
    doc.text(`Lucro Líquido:`, col1, summaryStartY + 16);
    doc.setTextColor(0, 128, 0);
    doc.setFont(undefined, "bold");
    doc.setFontSize(12);
    doc.text(formatCurrency(lucroLiquidoTotal), col1 + 32, summaryStartY + 16);
    
    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    doc.text(`Total de Contratos: ${comissoesPagas.length}`, col2, summaryStartY + 16);
    
    // Tabela de Contratos Pagos
    doc.setFontSize(14);
    doc.setTextColor(0, 100, 0);
    doc.text("DETALHAMENTO DE CONTRATOS", 14, 88);
    doc.setLineWidth(0.5);
    doc.line(14, 90, 196, 90);
    
    const tableData = comissoesPagas.map((comissao) => {
      const base = comissao.valor_recebido || comissao.valor_empresa || 0;
      const isAtendente = (comissao.perfil_operador || "ATENDENTE").toUpperCase() === "ATENDENTE";
      const isCorretor = (comissao.perfil_operador || "").toUpperCase() === "CORRETOR";
      const valorOperador = isAtendente ? (base * (comissao.percentual_atendente || 5)) / 100 : isCorretor ? (base * (comissao.percentual_corretor || 30)) / 100 : 0;
      const valorGerAdm = (base * (comissao.percentual_ger_adm || 10)) / 100;
      const valorImposto = (base * (comissao.percentual_imposto || 15)) / 100;
      const lucro = base - valorOperador - valorGerAdm - valorImposto;
      const operadorNome = (comissao.operador || comissao.vendedor || "-").split(" ").slice(0, 2).join(" ");
      
      return [
        formatDate(comissao.data_pagamento),
        operadorNome,
        comissao.cliente_nome || "-",
        comissao.numero_contrato || "-",
        comissao.banco_nome || "-",
        formatCurrency(comissao.valor_contrato),
        formatCurrency(base),
        formatCurrency(valorOperador),
        formatCurrency(valorGerAdm),
        formatCurrency(valorImposto),
        formatCurrency(lucro)
      ];
    });
    
    autoTable(doc, {
      startY: 95,
      head: [["Data", "Operador", "Cliente", "Contrato", "Banco", "Vlr. Contrato", "Com. Recebida", "Operador", "Ger. Adm", "Imposto", "Lucro"]],
      body: tableData,
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: [34, 139, 34], textColor: 255, fontSize: 7 },
      alternateRowStyles: { fillColor: [245, 255, 245] },
      foot: [[
        "TOTAIS", "", "", "", "",
        "",
        formatCurrency(totalRecebidoEmpresa),
        formatCurrency(totalPagoOperadores),
        formatCurrency(totalPagoGerAdm),
        formatCurrency(totalImpostos),
        formatCurrency(lucroLiquidoTotal)
      ]],
      footStyles: { fillColor: [34, 139, 34], textColor: 255, fontStyle: "bold", fontSize: 7 }
    });
    
    // Footer
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text("StiloCred - Sistema de Gestão de Comissões", 105, pageHeight - 10, { align: "center" });
    
    // Salvar
    doc.save(`comissoes_pagas_${dataAtual.replace(/\//g, "-")}.pdf`);
    toast.success("Relatório PDF gerado com sucesso!");
  };

  // Função para gerar PDF de um operador específico
  const gerarPDFOperador = (operador, comissoesOperador) => {
    const partesNome = operador.nome.trim().split(" ");
    const nomeOperador = partesNome.slice(1).join(" ") || operador.nome;
    const isCorretor = operador.perfil.toUpperCase() === "CORRETOR";
    const isAtendente = operador.perfil.toUpperCase() === "ATENDENTE";
    
    let totalPagoOperador = 0;
    comissoesOperador.forEach(c => {
      const base = c.valor_recebido || c.valor_empresa || 0;
      if (isAtendente) totalPagoOperador += (base * (c.percentual_atendente || 5)) / 100;
      else if (isCorretor) totalPagoOperador += (base * (c.percentual_corretor || 30)) / 100;
    });
    
    const doc = new jsPDF();
    const dataAtual = new Date().toLocaleDateString("pt-BR");
    const cor = isCorretor ? [218, 165, 32] : [255, 140, 0];
    
    // Header
    doc.setFontSize(16);
    doc.setTextColor(cor[0], cor[1], cor[2]);
    doc.text(`RELATÓRIO DE COMISSÕES - ${nomeOperador.toUpperCase()}`, 105, 20, { align: "center" });
    
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text(`Perfil: ${operador.perfil} | Data de Emissão: ${dataAtual}`, 105, 28, { align: "center" });
    
    // Resumo
    doc.setFontSize(12);
    doc.setTextColor(cor[0], cor[1], cor[2]);
    doc.text("RESUMO", 14, 42);
    doc.setDrawColor(cor[0], cor[1], cor[2]);
    doc.line(14, 44, 196, 44);
    
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    doc.text(`Total de Contratos: ${comissoesOperador.length}`, 14, 52);
    doc.text(`Total Pago:`, 100, 52);
    doc.setTextColor(cor[0], cor[1], cor[2]);
    doc.setFont(undefined, "bold");
    doc.text(formatCurrency(totalPagoOperador), 125, 52);
    
    // Tabela
    const tableData = comissoesOperador.map((comissao) => {
      const base = comissao.valor_recebido || comissao.valor_empresa || 0;
      const percentual = isAtendente ? (comissao.percentual_atendente || 5) : (comissao.percentual_corretor || 30);
      const valorComissao = (base * percentual) / 100;
      
      return [
        formatDate(comissao.data_pagamento),
        comissao.cliente_nome || "-",
        comissao.numero_contrato || "-",
        comissao.banco_nome || "-",
        formatCurrency(comissao.valor_contrato),
        formatCurrency(valorComissao)
      ];
    });
    
    autoTable(doc, {
      startY: 60,
      head: [["Data Pgto.", "Cliente", "Contrato", "Banco", "Valor Contrato", "Comissão"]],
      body: tableData,
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: { fillColor: cor, textColor: 255, fontSize: 9 },
      alternateRowStyles: { fillColor: [255, 250, 240] },
      foot: [["TOTAL", "", "", "", "", formatCurrency(totalPagoOperador)]],
      footStyles: { fillColor: cor, textColor: 255, fontStyle: "bold", fontSize: 9 }
    });
    
    // Footer
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text("StiloCred - Sistema de Gestão de Comissões", 105, pageHeight - 10, { align: "center" });
    
    // Salvar
    const nomeArquivo = nomeOperador.replace(/\s+/g, "_").toLowerCase();
    doc.save(`comissoes_${nomeArquivo}_${dataAtual.replace(/\//g, "-")}.pdf`);
    toast.success(`Relatório de ${nomeOperador} gerado!`);
  };

  // Função para gerar PDF do Gerente Administrativo
  const gerarPDFGerAdm = () => {
    const comissoesPagas = comissoes.filter(c => c.status === "PAGO");
    
    if (comissoesPagas.length === 0) {
      toast.error("Não há comissões pagas para gerar relatório");
      return;
    }
    
    const totalPagoGerAdm = comissoesPagas.reduce((acc, c) => {
      const base = c.valor_recebido || c.valor_empresa || 0;
      return acc + (base * (c.percentual_ger_adm || 10)) / 100;
    }, 0);
    
    const doc = new jsPDF();
    const dataAtual = new Date().toLocaleDateString("pt-BR");
    const cor = [128, 0, 128];
    
    // Header
    doc.setFontSize(16);
    doc.setTextColor(cor[0], cor[1], cor[2]);
    doc.text("RELATÓRIO GERENTE ADMINISTRATIVO", 105, 20, { align: "center" });
    
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text(`Data de Emissão: ${dataAtual}`, 105, 28, { align: "center" });
    
    // Resumo
    doc.setFontSize(12);
    doc.setTextColor(cor[0], cor[1], cor[2]);
    doc.text("RESUMO", 14, 42);
    doc.setDrawColor(cor[0], cor[1], cor[2]);
    doc.line(14, 44, 196, 44);
    
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    doc.text(`Total de Contratos: ${comissoesPagas.length}`, 14, 52);
    doc.text(`Total Pago:`, 100, 52);
    doc.setTextColor(cor[0], cor[1], cor[2]);
    doc.setFont(undefined, "bold");
    doc.text(formatCurrency(totalPagoGerAdm), 125, 52);
    
    // Tabela
    const tableData = comissoesPagas.map((comissao) => {
      const base = comissao.valor_recebido || comissao.valor_empresa || 0;
      const valorGerAdm = (base * (comissao.percentual_ger_adm || 10)) / 100;
      const operadorNome = (comissao.operador || comissao.vendedor || "-").split(" ").slice(0, 2).join(" ");
      
      return [
        formatDate(comissao.data_pagamento),
        operadorNome,
        comissao.cliente_nome || "-",
        comissao.numero_contrato || "-",
        comissao.banco_nome || "-",
        formatCurrency(comissao.valor_contrato),
        formatCurrency(valorGerAdm)
      ];
    });
    
    autoTable(doc, {
      startY: 60,
      head: [["Data Pgto.", "Operador", "Cliente", "Contrato", "Banco", "Valor Contrato", "Com. Ger. Adm"]],
      body: tableData,
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: { fillColor: cor, textColor: 255, fontSize: 9 },
      alternateRowStyles: { fillColor: [250, 240, 255] },
      foot: [["TOTAL", "", "", "", "", "", formatCurrency(totalPagoGerAdm)]],
      footStyles: { fillColor: cor, textColor: 255, fontStyle: "bold", fontSize: 9 }
    });
    
    // Footer
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text("StiloCred - Sistema de Gestão de Comissões", 105, pageHeight - 10, { align: "center" });
    
    // Salvar
    doc.save(`relatorio_ger_adm_${dataAtual.replace(/\//g, "-")}.pdf`);
    toast.success("Relatório Ger. Adm gerado com sucesso!");
  };

  // Função para gerar PDF de comissões pendentes de um operador
  const gerarPDFOperadorPendente = (operador, comissoesOperador) => {
    const partesNome = operador.nome.trim().split(" ");
    const nomeOperador = partesNome.slice(1).join(" ") || operador.nome;
    const isCorretor = operador.perfil.toUpperCase() === "CORRETOR";
    const isAtendente = operador.perfil.toUpperCase() === "ATENDENTE";
    
    let totalPendente = 0;
    comissoesOperador.forEach(c => {
      const base = c.valor_recebido || c.valor_empresa || 0;
      if (isAtendente) totalPendente += (base * (c.percentual_atendente || 5)) / 100;
      else if (isCorretor) totalPendente += (base * (c.percentual_corretor || 30)) / 100;
    });
    
    const doc = new jsPDF();
    const dataAtual = new Date().toLocaleDateString("pt-BR");
    const cor = isCorretor ? [218, 165, 32] : [255, 140, 0];
    
    // Header
    doc.setFontSize(16);
    doc.setTextColor(cor[0], cor[1], cor[2]);
    doc.text(`COMISSÕES PENDENTES - ${nomeOperador.toUpperCase()}`, 105, 20, { align: "center" });
    
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text(`Perfil: ${operador.perfil} | Data de Emissão: ${dataAtual}`, 105, 28, { align: "center" });
    
    // Resumo
    doc.setFontSize(12);
    doc.setTextColor(cor[0], cor[1], cor[2]);
    doc.text("RESUMO", 14, 42);
    doc.setDrawColor(cor[0], cor[1], cor[2]);
    doc.line(14, 44, 196, 44);
    
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    doc.text(`Total de Contratos Pendentes: ${comissoesOperador.length}`, 14, 52);
    doc.text(`Total a Pagar:`, 100, 52);
    doc.setTextColor(cor[0], cor[1], cor[2]);
    doc.setFont(undefined, "bold");
    doc.text(formatCurrency(totalPendente), 130, 52);
    
    // Tabela
    const tableData = comissoesOperador.map((comissao) => {
      const base = comissao.valor_recebido || comissao.valor_empresa || 0;
      const percentual = isAtendente ? (comissao.percentual_atendente || 5) : (comissao.percentual_corretor || 30);
      const valorComissao = (base * percentual) / 100;
      
      return [
        comissao.cliente_nome || "-",
        comissao.numero_contrato || "-",
        comissao.banco_nome || "-",
        formatCurrency(comissao.valor_contrato),
        formatCurrency(valorComissao),
        formatDate(comissao.data_recebimento)
      ];
    });
    
    autoTable(doc, {
      startY: 60,
      head: [["Cliente", "Contrato", "Banco", "Valor Contrato", "Comissão", "Data Receb."]],
      body: tableData,
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: { fillColor: cor, textColor: 255, fontSize: 9 },
      alternateRowStyles: { fillColor: [255, 250, 240] },
      foot: [["TOTAL A PAGAR", "", "", "", formatCurrency(totalPendente), ""]],
      footStyles: { fillColor: cor, textColor: 255, fontStyle: "bold", fontSize: 9 }
    });
    
    // Footer
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text("StiloCred - Sistema de Gestão de Comissões", 105, pageHeight - 10, { align: "center" });
    
    // Salvar
    const nomeArquivo = nomeOperador.replace(/\s+/g, "_").toLowerCase();
    doc.save(`pendente_${nomeArquivo}_${dataAtual.replace(/\//g, "-")}.pdf`);
    toast.success(`Relatório pendente de ${nomeOperador} gerado!`);
  };

  // Função para gerar PDF de comissões pendentes do Gerente Administrativo
  const gerarPDFGerAdmPendente = (comissoesPendentes) => {
    if (comissoesPendentes.length === 0) {
      toast.error("Não há comissões pendentes para gerar relatório");
      return;
    }
    
    const totalGerAdm = comissoesPendentes.reduce((acc, c) => {
      const base = c.valor_recebido || c.valor_empresa || 0;
      return acc + (base * (c.percentual_ger_adm || 10)) / 100;
    }, 0);
    
    const doc = new jsPDF("landscape");
    const dataAtual = new Date().toLocaleDateString("pt-BR");
    const cor = [128, 0, 128];
    
    // Header
    doc.setFontSize(16);
    doc.setTextColor(cor[0], cor[1], cor[2]);
    doc.text("COMISSÕES PENDENTES - GERENTE ADMINISTRATIVO", 148, 15, { align: "center" });
    
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text(`Data de Emissão: ${dataAtual}`, 148, 22, { align: "center" });
    
    // Resumo
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    doc.text(`Total de Contratos Pendentes: ${comissoesPendentes.length}`, 14, 32);
    doc.text(`Total a Pagar:`, 180, 32);
    doc.setTextColor(cor[0], cor[1], cor[2]);
    doc.setFont(undefined, "bold");
    doc.text(formatCurrency(totalGerAdm), 205, 32);
    
    // Tabela
    const tableData = comissoesPendentes.map((comissao) => {
      const base = comissao.valor_recebido || comissao.valor_empresa || 0;
      const valorGerAdm = (base * (comissao.percentual_ger_adm || 10)) / 100;
      const operadorNome = (comissao.operador || comissao.vendedor || "-").split(" ").slice(0, 2).join(" ");
      
      return [
        operadorNome,
        comissao.perfil_operador || "ATENDENTE",
        comissao.cliente_nome || "-",
        comissao.numero_contrato || "-",
        comissao.banco_nome || "-",
        formatCurrency(comissao.valor_contrato),
        `${comissao.percentual_ger_adm || 10}%`,
        formatCurrency(valorGerAdm),
        formatDate(comissao.data_recebimento)
      ];
    });
    
    autoTable(doc, {
      startY: 38,
      head: [["Operador", "Perfil", "Cliente", "Contrato", "Banco", "Vlr. Contrato", "%", "Com. Ger. Adm", "Data Receb."]],
      body: tableData,
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: cor, textColor: 255, fontSize: 8 },
      alternateRowStyles: { fillColor: [250, 240, 255] },
      foot: [["TOTAL A PAGAR", "", "", "", "", "", "", formatCurrency(totalGerAdm), ""]],
      footStyles: { fillColor: cor, textColor: 255, fontStyle: "bold", fontSize: 8 }
    });
    
    // Footer
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text("StiloCred - Sistema de Gestão de Comissões", 148, pageHeight - 10, { align: "center" });
    
    // Salvar
    doc.save(`pendente_ger_adm_${dataAtual.replace(/\//g, "-")}.pdf`);
    toast.success("Relatório pendente Ger. Adm gerado!");
  };

  useEffect(() => {
    carregarDados();
    carregarGestaoContas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodoFiltro, filtroMesLanc, filtroAnoLanc, filtroContaLanc]);

  // Carregar usuário logado
  useEffect(() => {
    const usuario = JSON.parse(localStorage.getItem("usuario") || "{}");
    setUsuarioLogado(usuario);
  }, []);

  // --- Gestão de Contas functions ---
  const carregarGestaoContas = async () => {
    try {
      const lancQuery = (filtroMesLanc !== "todos" && filtroAnoLanc !== "todos")
        ? `mes=${filtroMesLanc}&ano=${filtroAnoLanc}`
        : `periodo=${periodoFiltro}`;
      const saldoBase = (filtroMesLanc !== "todos" && filtroAnoLanc !== "todos")
        ? `mes=${filtroMesLanc}&ano=${filtroAnoLanc}`
        : `periodo=${periodoFiltro === "todos" ? "todos" : periodoFiltro}`;
      const saldoQuery = saldoBase + (filtroContaLanc !== "todos" ? `&conta_id=${filtroContaLanc}` : "");
      const [contasRes, lancRes, saldoRes, catRes] = await Promise.all([
        axios.get(`${API}/gestao-contas/contas`),
        axios.get(`${API}/gestao-contas/lancamentos?${lancQuery}`),
        axios.get(`${API}/gestao-contas/saldo?${saldoQuery}`),
        axios.get(`${API}/gestao-contas/categorias`)
      ]);
      setGestaoContas(contasRes.data);
      setGestaoLancamentos(lancRes.data);
      setGestaoSaldo(saldoRes.data);
      setCategoriasGestao(catRes.data || []);
    } catch (error) {
      console.error("Erro ao carregar gestão de contas:", error);
    }
  };

  const salvarValorPago = async (lanc) => {
    const raw = valorPagoEdits[lanc.id];
    if (raw === undefined) return;
    const valorPago = raw === "" ? 0 : parseFloat(raw);
    if (isNaN(valorPago)) { toast.error("Valor Pago inválido"); return; }
    if (valorPago === (lanc.valor_pago || 0)) {
      setValorPagoEdits(prev => { const p = { ...prev }; delete p[lanc.id]; return p; });
      return;
    }
    try {
      const r = await axios.put(`${API}/gestao-contas/lancamentos/${lanc.id}/valor-pago`, { valor_pago: valorPago });
      setGestaoLancamentos(prev => prev.map(l => l.id === lanc.id ? { ...l, valor_pago: r.data.valor_pago, diferenca: r.data.diferenca } : l));
      setValorPagoEdits(prev => { const p = { ...prev }; delete p[lanc.id]; return p; });
      toast.success("Valor Pago atualizado");
    } catch (e) {
      toast.error("Erro ao salvar Valor Pago");
    }
  };

  const salvarConta = async () => {
    try {
      if (!novaConta.nome.trim()) { toast.error("Nome da conta é obrigatório"); return; }
      await axios.post(`${API}/gestao-contas/contas`, { ...novaConta, saldo_inicial: parseFloat(novaConta.saldo_inicial) || 0 });
      toast.success("Conta criada com sucesso!");
      setShowNovaConta(false);
      setNovaConta({ nome: "", tipo: "ATIVO", categoria: "", saldo_inicial: "0" });
      carregarGestaoContas();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao criar conta");
    }
  };

  const adicionarCategoria = async () => {
    const nome = (novaCategoriaNome || "").trim();
    if (!nome) { toast.error("Informe o nome da conta"); return; }
    try {
      await axios.post(`${API}/gestao-contas/categorias`, { nome });
      setNovaCategoriaNome("");
      const r = await axios.get(`${API}/gestao-contas/categorias`);
      setCategoriasGestao(r.data || []);
      toast.success("Conta adicionada!");
    } catch (e) { toast.error(e.response?.data?.detail || "Erro ao adicionar"); }
  };

  const excluirCategoria = async (id) => {
    try {
      await axios.delete(`${API}/gestao-contas/categorias/${id}`);
      const r = await axios.get(`${API}/gestao-contas/categorias`);
      setCategoriasGestao(r.data || []);
      toast.success("Conta removida!");
    } catch (e) { toast.error(e.response?.data?.detail || "Erro ao remover"); }
  };

  const salvarLancamento = async () => {
    try {
      if (!novoLancamento.descricao.trim()) { toast.error("Descrição é obrigatória"); return; }
      if (!novoLancamento.valor || parseFloat(novoLancamento.valor) <= 0) { toast.error("Valor deve ser maior que zero"); return; }
      if (!novoLancamento.conta_id) { toast.error("Selecione uma conta"); return; }
      const usuario = JSON.parse(localStorage.getItem("usuario") || "{}");
      const resp = await axios.post(`${API}/gestao-contas/lancamentos`, {
        ...novoLancamento, valor: parseFloat(novoLancamento.valor), parcelas: parseInt(novoLancamento.parcelas) || 1, created_by: usuario.nome || "admin"
      });
      const totalCriado = resp.data?.total || 1;
      toast.success(totalCriado > 1 ? `${totalCriado} parcelas criadas com sucesso!` : "Lançamento criado com sucesso!");
      setShowNovoLancamento(false);
      setNovoLancamento({ data: new Date().toISOString().split('T')[0], tipo: "CREDITO", descricao: "", valor: "", conta_id: "", categoria: "", centro_custo: "", observacao: "", tipo_cobranca: "unica", parcelas: 1, baixar_auto: false });
      carregarGestaoContas();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao criar lançamento");
    }
  };

  const baixarLancamento = async (lancamentoId) => {
    try {
      const usuario = JSON.parse(localStorage.getItem("usuario") || "{}");
      await axios.put(`${API}/gestao-contas/lancamentos/${lancamentoId}/baixar`, { ...baixaData, baixado_por: usuario.nome || "admin" });
      toast.success("Baixa realizada com sucesso!");
      setShowBaixa(null);
      setBaixaData({ data_baixa: new Date().toISOString().split('T')[0], forma_pagamento: "", observacao: "" });
      carregarGestaoContas();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao dar baixa");
    }
  };

  const baixarInline = async (lanc) => {
    try {
      const usuario = JSON.parse(localStorage.getItem("usuario") || "{}");
      const forma = formaPgtoLanc[lanc.id] || "Comissão Recebidas";
      await axios.put(`${API}/gestao-contas/lancamentos/${lanc.id}/baixar`, {
        data_baixa: new Date().toISOString().split('T')[0], forma_pagamento: forma, observacao: "", baixado_por: usuario.nome || "admin"
      });
      toast.success(`Baixa realizada (${forma})!`);
      carregarGestaoContas();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao dar baixa");
    }
  };

  const cancelarBaixaLancamento = async (lancamentoId) => {
    try {
      await axios.put(`${API}/gestao-contas/lancamentos/${lancamentoId}/cancelar-baixa`);
      toast.success("Baixa cancelada!");
      carregarGestaoContas();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao cancelar baixa");
    }
  };

  const estornarLancamento = async (lancamentoId) => {
    try {
      if (!estornoMotivo.trim()) { toast.error("Motivo do estorno é obrigatório"); return; }
      const usuario = JSON.parse(localStorage.getItem("usuario") || "{}");
      await axios.put(`${API}/gestao-contas/lancamentos/${lancamentoId}/estornar`, { motivo: estornoMotivo, estornado_por: usuario.nome || "admin" });
      toast.success("Lançamento estornado!");
      setShowEstorno(null);
      setEstornoMotivo("");
      carregarGestaoContas();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao estornar");
    }
  };

  const excluirLancamento = async (lancamentoId) => {
    try {
      await axios.delete(`${API}/gestao-contas/lancamentos/${lancamentoId}`);
      toast.success("Lançamento excluído!");
      carregarGestaoContas();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao excluir");
    }
  };

  const excluirConta = async (contaId) => {
    try {
      await axios.delete(`${API}/gestao-contas/contas/${contaId}`);
      toast.success("Conta excluída!");
      carregarGestaoContas();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao excluir conta");
    }
  };

  const categoriasLancamento = ["Comissão", "Salário", "Aluguel", "Energia", "Telefonia", "Marketing", "Sistemas", "Material", "Transporte", "Alimentação", "Impostos", "Bonificação", "Outros"];

  const carregarDados = async () => {
    setLoading(true);
    try {
      // Verificar se usuário é ATENDENTE ou CORRETOR para filtrar
      const usuario = JSON.parse(localStorage.getItem("usuario") || "{}");
      const perfilUsuario = (usuario.perfil || "").toUpperCase();
      const isAtendenteOuCorretor = perfilUsuario === "ATENDENTE" || perfilUsuario === "CORRETOR";
      
      // Montar query params para filtrar comissões por operador
      // ATENDENTE e CORRETOR só veem SUAS PRÓPRIAS comissões
      let filtroOperadorComissao = "";
      let nomeBusca = usuario.nome;
      if (usuario.codigo_usuario) {
        nomeBusca = `${usuario.codigo_usuario} ${usuario.nome}`.trim();
      }
      
      if (isAtendenteOuCorretor && nomeBusca) {
        filtroOperadorComissao = `&operador=${encodeURIComponent(nomeBusca)}`;
      }
      
      const [resumoRes, comissoesRes, transacoesRes, debitosRes] = await Promise.all([
        axios.get(`${API}/financeiro/resumo?periodo=${periodoFiltro}${filtroOperadorComissao}`),
        axios.get(`${API}/financeiro/comissoes?periodo=${periodoFiltro}${filtroOperadorComissao}`),
        axios.get(`${API}/financeiro/transacoes?periodo=${periodoFiltro}`),
        axios.get(`${API}/debitos-comissao${isAtendenteOuCorretor && nomeBusca ? `?beneficiario=${encodeURIComponent(nomeBusca)}` : ''}`)
      ]);
      
      setResumo(resumoRes.data);
      setComissoes(comissoesRes.data);
      setTransacoes(transacoesRes.data);
      setDebitos(debitosRes.data.debitos || []);
      setDebitosResumo({
        total_pendente: debitosRes.data.total_pendente || 0,
        total_processado: debitosRes.data.total_processado || 0
      });
    } catch (error) {
      console.error("Erro ao carregar dados financeiros:", error);
      // Dados mock para demonstração
      setResumo({
        receita_total: 125750.00,
        despesa_total: 45230.00,
        saldo: 80520.00,
        comissoes_pendentes: 12500.00,
        comissoes_pagas: 38200.00,
        contratos_mes: 47,
        ticket_medio: 2675.53
      });
      setComissoes([]);
      setTransacoes([]);
      setDebitos([]);
      setDebitosResumo({ total_pendente: 0, total_processado: 0 });
    } finally {
      setLoading(false);
    }
  };

  const salvarTransacao = async () => {
    try {
      await axios.post(`${API}/financeiro/transacoes`, novaTransacao);
      toast.success("Transação registrada com sucesso!");
      setShowNovaTransacao(false);
      setNovaTransacao({
        tipo: "RECEITA",
        categoria: "",
        descricao: "",
        valor: "",
        data: new Date().toISOString().split('T')[0],
        status: "PENDENTE",
        cliente_id: "",
        contrato_id: "",
        observacao: ""
      });
      carregarDados();
    } catch (error) {
      toast.error("Erro ao registrar transação");
      console.error(error);
    }
  };

  // Função para marcar comissão como recebida (pela empresa do banco)
  const receberComissao = async (comissaoId) => {
    try {
      await axios.put(`${API}/financeiro/comissoes/${comissaoId}/receber`);
      toast.success("Comissão marcada como recebida! Pagamentos aos operadores liberados.");
      carregarDados();
    } catch (error) {
      toast.error("Erro ao marcar comissão como recebida");
      console.error(error);
    }
  };

  // Função para marcar comissão como paga (aos operadores)
  const pagarComissao = async (comissaoId) => {
    try {
      const response = await axios.put(`${API}/financeiro/comissoes/${comissaoId}/pagar`);
      
      // Verificar se houve desconto de débitos
      if (response.data.debitos_descontados && response.data.debitos_descontados.length > 0) {
        const totalDescontado = response.data.debitos_descontados.reduce((acc, d) => acc + d.valor_descontado, 0);
        toast.success(
          `Comissão paga!\n\n💰 Valor bruto: ${formatCurrency(response.data.valor_bruto)}\n⚠️ Débitos descontados: ${formatCurrency(totalDescontado)}\n✅ Valor líquido: ${formatCurrency(response.data.valor_liquido)}`,
          { duration: 5000 }
        );
      } else {
        toast.success("Comissão marcada como paga!");
      }
      carregarDados();
    } catch (error) {
      toast.error("Erro ao marcar comissão como paga");
      console.error(error);
    }
  };

  // Função para atualizar valor recebido da comissão
  const atualizarValorRecebido = async (comissaoId, valorRecebido) => {
    try {
      await axios.put(`${API}/financeiro/comissoes/${comissaoId}/valor-recebido`, {
        valor_recebido: valorRecebido
      });
      toast.success("Valor recebido atualizado!");
      carregarDados();
    } catch (error) {
      toast.error("Erro ao atualizar valor recebido");
      console.error(error);
    }
  };

  // Função para processar arquivo de importação do banco
  const handleImportRelatorioChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    setImportRelatorioFile(file);
    setImportRelatorioPreview(null);
    
    // Verificar extensão
    const ext = file.name.split('.').pop().toLowerCase();
    if (!['xlsx', 'xls', 'csv'].includes(ext)) {
      toast.error("Formato inválido. Use arquivos Excel (.xlsx, .xls) ou CSV (.csv)");
      return;
    }
    
    // Criar preview do arquivo
    setImportRelatorioPreview({
      nome: file.name,
      tamanho: (file.size / 1024).toFixed(2) + ' KB',
      tipo: ext.toUpperCase()
    });
  };
  
  // Função para importar relatório do banco e conciliar comissões
  const importarRelatorioBanco = async () => {
    if (!importRelatorioFile) {
      toast.error("Selecione o arquivo");
      return;
    }
    if (!importRelatorioBanco && importRelatorioFormato === "padrao") {
      toast.error("Selecione o banco");
      return;
    }
    
    setImportRelatorioLoading(true);
    
    try {
      const formData = new FormData();
      formData.append("arquivo", importRelatorioFile);
      formData.append("banco", importRelatorioBanco);
      formData.append("formato", importRelatorioFormato);
      
      const response = await axios.post(`${API}/financeiro/importar-relatorio-banco`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      
      if (response.data.success) {
        setShowImportarRelatorioBanco(false);
        setImportRelatorioFile(null);
        setImportRelatorioBanco("");
        setImportRelatorioFormato("padrao");
        setImportRelatorioPreview(null);
        setImportRelatorioResultado(response.data);
        carregarDados();
      } else {
        toast.error(response.data.message || "Erro na importação");
      }
    } catch (error) {
      console.error("Erro ao importar relatório:", error);
      toast.error(error.response?.data?.detail || "Erro ao importar relatório do banco");
    } finally {
      setImportRelatorioLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      PENDENTE: { color: "bg-yellow-100 text-yellow-800", icon: Clock },
      PENDENTE_RECEBIMENTO: { color: "bg-orange-100 text-orange-800", icon: Clock },
      PENDENTE_PAGAMENTO: { color: "bg-yellow-100 text-yellow-800", icon: CircleDollarSign },
      PAGO: { color: "bg-green-100 text-green-800", icon: CheckCircle },
      CONFIRMADO: { color: "bg-green-100 text-green-800", icon: CheckCircle },
      CANCELADO: { color: "bg-red-100 text-red-800", icon: XCircle },
      ATRASADO: { color: "bg-red-100 text-red-800", icon: AlertCircle }
    };
    const config = statusConfig[status] || statusConfig.PENDENTE;
    const Icon = config.icon;
    return (
      <Badge className={`${config.color} gap-1`}>
        <Icon className="h-3 w-3" />
        {status}
      </Badge>
    );
  };

  const categoriasReceita = [
    "Comissão Banco",
    "Comissão Loja",
    "Bonificação",
    "Premiação",
    "Outros"
  ];

  const categoriasDespesa = [
    "Comissão Corretor",
    "Aluguel",
    "Salários",
    "Marketing",
    "Sistemas",
    "Telefonia",
    "Energia",
    "Material Escritório",
    "Outros"
  ];

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Financeiro</h1>
          <p className="text-gray-500 mt-1">Gestão financeira e controle de comissões</p>
        </div>
        <div className="flex items-center gap-3">
          <Select value={periodoFiltro} onValueChange={setPeriodoFiltro}>
            <SelectTrigger className="w-[180px]">
              <Calendar className="h-4 w-4 mr-2" />
              <SelectValue placeholder="Período" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="hoje">Hoje</SelectItem>
              <SelectItem value="semana">Esta Semana</SelectItem>
              <SelectItem value="mes">Este Mês</SelectItem>
              <SelectItem value="trimestre">Este Trimestre</SelectItem>
              <SelectItem value="ano">Este Ano</SelectItem>
            </SelectContent>
          </Select>
          <Button variant="outline" className="gap-2">
            <Download className="h-4 w-4" />
            Exportar
          </Button>
          <Dialog open={showNovaTransacao} onOpenChange={setShowNovaTransacao}>
            <DialogTrigger asChild>
              <Button className="gap-2 bg-green-600 hover:bg-green-700">
                <Plus className="h-4 w-4" />
                Nova Transação
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-md">
              <DialogHeader>
                <DialogTitle>Nova Transação</DialogTitle>
                <DialogDescription>Registre uma nova receita ou despesa</DialogDescription>
              </DialogHeader>
              <div className="space-y-4 py-4">
                <div className="flex gap-2">
                  <Button
                    type="button"
                    variant={tipoTransacao === "RECEITA" ? "default" : "outline"}
                    className={`flex-1 gap-2 ${tipoTransacao === "RECEITA" ? "bg-green-600 hover:bg-green-700" : ""}`}
                    onClick={() => {
                      setTipoTransacao("RECEITA");
                      setNovaTransacao({...novaTransacao, tipo: "RECEITA", categoria: ""});
                    }}
                  >
                    <ArrowUpRight className="h-4 w-4" />
                    Receita
                  </Button>
                  <Button
                    type="button"
                    variant={tipoTransacao === "DESPESA" ? "default" : "outline"}
                    className={`flex-1 gap-2 ${tipoTransacao === "DESPESA" ? "bg-red-600 hover:bg-red-700" : ""}`}
                    onClick={() => {
                      setTipoTransacao("DESPESA");
                      setNovaTransacao({...novaTransacao, tipo: "DESPESA", categoria: ""});
                    }}
                  >
                    <ArrowDownLeft className="h-4 w-4" />
                    Despesa
                  </Button>
                </div>
                
                <div>
                  <Label>Categoria *</Label>
                  <Select 
                    value={novaTransacao.categoria} 
                    onValueChange={(v) => setNovaTransacao({...novaTransacao, categoria: v})}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Selecione a categoria" />
                    </SelectTrigger>
                    <SelectContent>
                      {(tipoTransacao === "RECEITA" ? categoriasReceita : categoriasDespesa).map((cat) => (
                        <SelectItem key={cat} value={cat}>{cat}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                <div>
                  <Label>Descrição *</Label>
                  <Input
                    value={novaTransacao.descricao}
                    onChange={(e) => setNovaTransacao({...novaTransacao, descricao: e.target.value})}
                    placeholder="Descreva a transação"
                  />
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Valor (R$) *</Label>
                    <Input
                      type="number"
                      step="0.01"
                      value={novaTransacao.valor}
                      onChange={(e) => setNovaTransacao({...novaTransacao, valor: e.target.value})}
                      placeholder="0,00"
                    />
                  </div>
                  <div>
                    <Label>Data *</Label>
                    <Input
                      type="date"
                      value={novaTransacao.data}
                      onChange={(e) => setNovaTransacao({...novaTransacao, data: e.target.value})}
                    />
                  </div>
                </div>
                
                <div>
                  <Label>Status</Label>
                  <Select 
                    value={novaTransacao.status} 
                    onValueChange={(v) => setNovaTransacao({...novaTransacao, status: v})}
                  >
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="PENDENTE">Pendente</SelectItem>
                      <SelectItem value="CONFIRMADO">Confirmado</SelectItem>
                      <SelectItem value="PAGO">Pago</SelectItem>
                      <SelectItem value="CANCELADO">Cancelado</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                
                <div>
                  <Label>Observação</Label>
                  <Input
                    value={novaTransacao.observacao}
                    onChange={(e) => setNovaTransacao({...novaTransacao, observacao: e.target.value})}
                    placeholder="Observações adicionais"
                  />
                </div>
              </div>
              <DialogFooter>
                <Button variant="outline" onClick={() => setShowNovaTransacao(false)}>Cancelar</Button>
                <Button 
                  onClick={salvarTransacao}
                  className={tipoTransacao === "RECEITA" ? "bg-green-600 hover:bg-green-700" : "bg-red-600 hover:bg-red-700"}
                >
                  Salvar
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </div>
      </div>

      {/* Cards de Resumo */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <Card className="border-l-4 border-l-green-500">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Receitas Comissão Recebidas</CardTitle>
            <div className="p-2 bg-green-100 rounded-full">
              <TrendingUp className="h-4 w-4 text-green-600" />
            </div>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-green-600">{formatCurrency((resumo.receita_total || 0) - gestaoLancamentos.filter(l => l.status === "BAIXADO" && l.tipo === "DEBITO" && (l.conta_nome || "").toUpperCase().includes("EMPRESA") && (l.conta_nome || "").toUpperCase().includes("STILO") && l.forma_pagamento === "Comissão Recebidas").reduce((a, l) => a + (l.valor || 0), 0))}</div>
            <p className="text-xs text-gray-500 mt-1">Comissões recebidas do banco (líquido)</p>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-l-red-500 cursor-pointer hover:shadow-md transition-shadow" onClick={() => setShowDespesasDetalhe(true)} data-testid="card-despesas">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Despesas</CardTitle>
            <div className="p-2 bg-red-100 rounded-full">
              <TrendingDown className="h-4 w-4 text-red-600" />
            </div>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-red-600">{formatCurrency(resumo.despesa_total)}</div>
            <p className="text-xs text-blue-500 mt-1 underline">Clique para detalhar</p>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-l-blue-500">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Saldo</CardTitle>
            <div className="p-2 bg-blue-100 rounded-full">
              <Wallet className="h-4 w-4 text-blue-600" />
            </div>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-blue-600">{formatCurrency(resumo.saldo)}</div>
            <p className="text-xs text-gray-500 mt-1">Lucro líquido do período</p>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-l-orange-500">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Pend. Recebimento</CardTitle>
            <div className="p-2 bg-orange-100 rounded-full">
              <Clock className="h-4 w-4 text-orange-600" />
            </div>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-orange-600">{formatCurrency(resumo.comissoes_pendentes_recebimento || 0)}</div>
            <p className="text-xs text-gray-500 mt-1">A receber do banco</p>
          </CardContent>
        </Card>
      </div>

      {/* Cards Secundários */}
      <div className="grid gap-4 md:grid-cols-4">
        <Card className="border-l-4 border-l-yellow-500">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Pend. Pagamento</CardTitle>
            <CircleDollarSign className="h-4 w-4 text-yellow-600" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-yellow-600">{formatCurrency(resumo.comissoes_pendentes_pagamento || 0)}</div>
            <p className="text-xs text-gray-500 mt-1">A pagar operadores</p>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-l-orange-500" data-testid="card-pend-pagamento-conta-mes">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Pend. Pagamento Conta do Mês</CardTitle>
            <CircleDollarSign className="h-4 w-4 text-orange-600" />
          </CardHeader>
          <CardContent>
            {(() => {
              const base = gestaoLancamentos.filter(l => l.tipo === "DEBITO" && l.status === "ABERTO");
              const filtrado = base
                .filter(l => filtroContaLanc === "todos" || l.conta_id === filtroContaLanc)
                .filter(l => filtroCategoriaLanc === "todos" || l.categoria === filtroCategoriaLanc);
              const total = filtrado.reduce((a, l) => a + (l.valor || 0), 0);
              const semFiltro = filtroContaLanc === "todos" && filtroCategoriaLanc === "todos";
              if (semFiltro) {
                const grupos = {};
                filtrado.forEach(l => { const k = l.conta_nome || "Sem Centro"; grupos[k] = (grupos[k] || 0) + (l.valor || 0); });
                const entries = Object.entries(grupos).sort((a, b) => b[1] - a[1]);
                return (
                  <>
                    <div className="text-2xl font-bold text-orange-600" data-testid="card-conta-mes-total">{formatCurrency(total)}</div>
                    {entries.length > 0 ? (
                      <div className="mt-2 space-y-1 max-h-28 overflow-y-auto pr-1" data-testid="card-conta-mes-breakdown">
                        {entries.map(([nome, val]) => (
                          <div key={nome} className="flex justify-between items-center text-xs" data-testid={`card-cc-item-${nome}`}>
                            <span className="text-gray-500 truncate mr-2">{nome}</span>
                            <span className="font-medium text-orange-600 whitespace-nowrap">{formatCurrency(val)}</span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-xs text-gray-500 mt-1">Contas a pagar em aberto</p>
                    )}
                  </>
                );
              }
              const ccNome = filtroContaLanc !== "todos" ? (gestaoContas.find(c => c.id === filtroContaLanc)?.nome || "") : "";
              const contaNome = filtroCategoriaLanc !== "todos" ? filtroCategoriaLanc : "";
              const legenda = [ccNome, contaNome].filter(Boolean).join(" • ");
              return (
                <>
                  <div className="text-2xl font-bold text-orange-600" data-testid="card-conta-mes-total">{formatCurrency(total)}</div>
                  <p className="text-xs text-gray-500 mt-1 truncate">{legenda || "Contas a pagar em aberto"}</p>
                </>
              );
            })()}
          </CardContent>

        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Contratos no Mês</CardTitle>
            <FileText className="h-4 w-4 text-gray-400" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{resumo.contratos_mes}</div>
            <p className="text-xs text-gray-500 mt-1">Contratos aprovados</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Ticket Médio</CardTitle>
            <BarChart3 className="h-4 w-4 text-gray-400" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{formatCurrency(resumo.ticket_medio)}</div>
            <p className="text-xs text-gray-500 mt-1">Por contrato aprovado</p>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-l-green-500">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">Comissões Pagas</CardTitle>
            <CheckCircle className="h-4 w-4 text-green-500" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-green-600">{formatCurrency(resumo.comissoes_pagas)}</div>
            <p className="text-xs text-gray-500 mt-1">Total pago no período</p>
          </CardContent>
        </Card>
      </div>

      {/* Tabs de Conteúdo */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <div className="overflow-x-auto">
          <TabsList className="inline-flex gap-1 bg-transparent p-1 min-w-max">
            <TabsTrigger value="lancamentos" className="gap-2 px-3 py-2 data-[state=active]:bg-blue-100">
              <Receipt className="h-4 w-4 text-blue-600" />
              <span className="text-blue-600 font-medium">Lancamentos</span>
            </TabsTrigger>
            <TabsTrigger value="baixas" className="gap-2 px-3 py-2 data-[state=active]:bg-green-100">
              <CheckCircle className="h-4 w-4 text-green-600" />
              <span className="text-green-600 font-medium">Baixas</span>
            </TabsTrigger>
            <TabsTrigger value="saldo" className="gap-2 px-3 py-2 data-[state=active]:bg-purple-100">
              <Wallet className="h-4 w-4 text-purple-600" />
              <span className="text-purple-600 font-medium">Centro de Custo</span>
            </TabsTrigger>
            <TabsTrigger value="comissoes" className="gap-2 px-3 py-2 data-[state=active]:bg-orange-100">
              <Clock className="h-4 w-4 text-orange-600" />
              <span className="text-orange-600 font-medium">Pend. Empresa</span>
            </TabsTrigger>
            <TabsTrigger value="comissoes_equipe" className="gap-2 px-3 py-2 data-[state=active]:bg-yellow-100">
              <Users className="h-4 w-4 text-yellow-600" />
              <span className="text-yellow-600 font-medium">Pend. Equipe</span>
            </TabsTrigger>
            <TabsTrigger value="comissoes_pagas" className="gap-2 px-3 py-2 data-[state=active]:bg-green-100">
              <CheckCircle className="h-4 w-4 text-green-600" />
              <span className="text-green-600 font-medium">Pagas</span>
            </TabsTrigger>
            <TabsTrigger value="debitos" className="gap-2 px-3 py-2 data-[state=active]:bg-red-100">
              <MinusCircle className="h-4 w-4" />
              Debitos
              {debitos.filter(d => d.status === "PENDENTE").length > 0 && (
                <Badge variant="destructive" className="ml-1 h-5 w-5 p-0 flex items-center justify-center text-[10px]">
                  {debitos.filter(d => d.status === "PENDENTE").length}
                </Badge>
              )}
            </TabsTrigger>
          </TabsList>
        </div>

        {/* ============ Tab: Lançamentos ============ */}
        <TabsContent value="lancamentos" className="space-y-4" data-testid="tab-lancamentos">
          <Card>
            <CardHeader className="flex flex-row items-center justify-between">
              <div>
                <CardTitle className="flex items-center gap-2">
                  <Receipt className="h-5 w-5 text-blue-600" />
                  Lançamentos (Créditos e Débitos)
                </CardTitle>
                <CardDescription>Registre e gerencie todos os lançamentos financeiros</CardDescription>
              </div>
              <div className="flex items-center gap-2">
                <Button variant="outline" size="sm" className="gap-1" onClick={() => setShowNovaConta(true)} data-testid="btn-nova-conta">
                  <Building2 className="h-4 w-4" /> Novo Centro de Custo
                </Button>
                <Button className="gap-1 bg-blue-600 hover:bg-blue-700" onClick={() => setShowNovoLancamento(true)} data-testid="btn-novo-lancamento">
                  <Plus className="h-4 w-4" /> Novo Lançamento
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              {/* Filtros */}
              <div className="flex flex-wrap gap-3 mb-4 p-3 bg-gray-50 rounded-lg">
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Status:</Label>
                  <Select value={filtroStatusLanc} onValueChange={setFiltroStatusLanc}>
                    <SelectTrigger className="w-[140px] h-9 bg-white"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      <SelectItem value="ABERTO">Aberto</SelectItem>
                      <SelectItem value="BAIXADO">Baixado</SelectItem>
                      <SelectItem value="ESTORNADO">Estornado</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Tipo:</Label>
                  <Select value={filtroTipoLanc} onValueChange={setFiltroTipoLanc}>
                    <SelectTrigger className="w-[140px] h-9 bg-white"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      <SelectItem value="CREDITO">Crédito</SelectItem>
                      <SelectItem value="DEBITO">Débito</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Centro de Custo:</Label>
                  <Select value={filtroContaLanc} onValueChange={setFiltroContaLanc}>
                    <SelectTrigger className="w-[180px] h-9 bg-white"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      {gestaoContas.map(c => (
                        <SelectItem key={c.id} value={c.id}>{c.nome}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Conta:</Label>
                  <Select value={filtroCategoriaLanc} onValueChange={setFiltroCategoriaLanc}>
                    <SelectTrigger className="w-[180px] h-9 bg-white" data-testid="filtro-conta-lanc"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todas</SelectItem>
                      {categoriasGestao.map(cat => (
                        <SelectItem key={cat.id} value={cat.nome}>{cat.nome}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Mês:</Label>
                  <Select value={filtroMesLanc} onValueChange={setFiltroMesLanc}>
                    <SelectTrigger className="w-[120px] h-9 bg-white" data-testid="filtro-mes-lanc"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      {["01","02","03","04","05","06","07","08","09","10","11","12"].map((m, i) => (
                        <SelectItem key={m} value={String(i+1)}>{["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"][i]}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Ano:</Label>
                  <Select value={filtroAnoLanc} onValueChange={setFiltroAnoLanc}>
                    <SelectTrigger className="w-[110px] h-9 bg-white" data-testid="filtro-ano-lanc"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      {[0,1,2,3].map(off => { const y = new Date().getFullYear() - off; return (<SelectItem key={y} value={String(y)}>{y}</SelectItem>); })}
                    </SelectContent>
                  </Select>
                </div>
                {(filtroStatusLanc !== "todos" || filtroTipoLanc !== "todos" || filtroContaLanc !== "todos" || filtroCategoriaLanc !== "todos" || filtroMesLanc !== "todos" || filtroAnoLanc !== "todos") && (
                  <Button variant="ghost" size="sm" className="h-9 text-red-600" onClick={() => { setFiltroStatusLanc("todos"); setFiltroTipoLanc("todos"); setFiltroContaLanc("todos"); setFiltroCategoriaLanc("todos"); setFiltroMesLanc("todos"); setFiltroAnoLanc("todos"); }}>
                    Limpar Filtros
                  </Button>
                )}
              </div>
              {/* Resumo rápido */}
              {(() => {
                const filtered = gestaoLancamentos
                  .filter(l => filtroStatusLanc === "todos" || l.status === filtroStatusLanc)
                  .filter(l => filtroTipoLanc === "todos" || l.tipo === filtroTipoLanc)
                  .filter(l => filtroContaLanc === "todos" || l.conta_id === filtroContaLanc)
                  .filter(l => filtroCategoriaLanc === "todos" || l.categoria === filtroCategoriaLanc);
                const totalCred = filtered.filter(l => l.tipo === "CREDITO" && l.status !== "ESTORNADO").reduce((a, l) => a + l.valor, 0);
                const totalDeb = filtered.filter(l => l.tipo === "DEBITO" && l.status !== "ESTORNADO").reduce((a, l) => a + l.valor, 0);
                return (
                  <div className="grid gap-3 md:grid-cols-3 mb-4">
                    <div className="p-3 rounded-lg bg-green-50 border border-green-200">
                      <p className="text-xs text-green-700 font-medium">Total Créditos</p>
                      <p className="text-lg font-bold text-green-700">{formatCurrency(totalCred)}</p>
                    </div>
                    <div className="p-3 rounded-lg bg-red-50 border border-red-200">
                      <p className="text-xs text-red-700 font-medium">Total Débitos</p>
                      <p className="text-lg font-bold text-red-700">{formatCurrency(totalDeb)}</p>
                    </div>
                    <div className="p-3 rounded-lg bg-blue-50 border border-blue-200">
                      <p className="text-xs text-blue-700 font-medium">Saldo Período</p>
                      <p className="text-lg font-bold text-blue-700">{formatCurrency(totalCred - totalDeb)}</p>
                    </div>
                  </div>
                );
              })()}
              {/* Tabela */}
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Data</TableHead>
                    <TableHead>Tipo</TableHead>
                    <TableHead>Descrição</TableHead>
                    <TableHead>Centro de Custo</TableHead>
                    <TableHead>Conta</TableHead>
                    <TableHead className="text-right">Valor</TableHead>
                    <TableHead className="text-right">Valor Pago</TableHead>
                    <TableHead className="text-right">Diferença</TableHead>
                    <TableHead>Status</TableHead>
                    <TableHead className="text-right">Ações</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {gestaoLancamentos
                    .filter(l => filtroStatusLanc === "todos" || l.status === filtroStatusLanc)
                    .filter(l => filtroTipoLanc === "todos" || l.tipo === filtroTipoLanc)
                    .filter(l => filtroContaLanc === "todos" || l.conta_id === filtroContaLanc)
                    .filter(l => filtroCategoriaLanc === "todos" || l.categoria === filtroCategoriaLanc)
                    .length === 0 ? (
                    <TableRow><TableCell colSpan={10} className="h-24 text-center text-muted-foreground">Nenhum lançamento encontrado</TableCell></TableRow>
                  ) : gestaoLancamentos
                    .filter(l => filtroStatusLanc === "todos" || l.status === filtroStatusLanc)
                    .filter(l => filtroTipoLanc === "todos" || l.tipo === filtroTipoLanc)
                    .filter(l => filtroContaLanc === "todos" || l.conta_id === filtroContaLanc)
                    .filter(l => filtroCategoriaLanc === "todos" || l.categoria === filtroCategoriaLanc)
                    .map((lanc) => (
                    <TableRow key={lanc.id} className={lanc.status === "ESTORNADO" ? "opacity-50 line-through" : ""} data-testid={`lancamento-row-${lanc.id}`}>
                      <TableCell className="text-sm">{formatDate(lanc.data)}</TableCell>
                      <TableCell>
                        <Badge className={lanc.tipo === "CREDITO" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}>
                          {lanc.tipo === "CREDITO" ? <ArrowUpRight className="h-3 w-3 mr-1" /> : <ArrowDownLeft className="h-3 w-3 mr-1" />}
                          {lanc.tipo}
                        </Badge>
                      </TableCell>
                      <TableCell className="max-w-[200px]">
                        <p className="text-sm font-medium truncate">{lanc.descricao}</p>
                        {lanc.observacao && <p className="text-xs text-gray-400 truncate">{lanc.observacao}</p>}
                        {lanc.estorno_motivo && <p className="text-xs text-red-500">Estorno: {lanc.estorno_motivo}</p>}
                      </TableCell>
                      <TableCell className="text-sm">{lanc.conta_nome || "-"}</TableCell>
                      <TableCell className="text-sm">{lanc.categoria || "-"}</TableCell>
                      <TableCell className={`text-right font-semibold ${lanc.tipo === "CREDITO" ? "text-green-600" : "text-red-600"}`}>
                        {lanc.tipo === "CREDITO" ? "+" : "-"}{formatCurrency(lanc.valor)}
                      </TableCell>
                      <TableCell className="text-right">
                        {lanc.status === "ESTORNADO" ? (
                          <span className="text-sm text-gray-400">-</span>
                        ) : (
                          <Input
                            type="number"
                            step="0.01"
                            min="0"
                            className="h-8 w-28 text-right text-sm ml-auto"
                            placeholder="0,00"
                            data-testid={`input-valor-pago-${lanc.id}`}
                            value={valorPagoEdits[lanc.id] !== undefined ? valorPagoEdits[lanc.id] : (lanc.valor_pago ?? "")}
                            onChange={(e) => setValorPagoEdits(prev => ({ ...prev, [lanc.id]: e.target.value }))}
                            onBlur={() => salvarValorPago(lanc)}
                            onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
                          />
                        )}
                      </TableCell>
                      <TableCell className="text-right" data-testid={`diferenca-${lanc.id}`}>
                        {(() => {
                          const vp = valorPagoEdits[lanc.id] !== undefined ? (valorPagoEdits[lanc.id] === "" ? 0 : parseFloat(valorPagoEdits[lanc.id])) : (lanc.valor_pago || 0);
                          const dif = (lanc.valor || 0) - (isNaN(vp) ? 0 : vp);
                          const cor = Math.abs(dif) < 0.005 ? "text-gray-500" : (dif > 0 ? "text-red-600" : "text-green-600");
                          return <span className={`text-sm font-semibold ${cor}`}>{formatCurrency(dif)}</span>;
                        })()}
                      </TableCell>
                      <TableCell>
                        <Badge className={
                          lanc.status === "ABERTO" ? "bg-yellow-100 text-yellow-800" :
                          lanc.status === "BAIXADO" ? "bg-green-100 text-green-800" :
                          "bg-gray-100 text-gray-800"
                        }>
                          {lanc.status === "ABERTO" && <Clock className="h-3 w-3 mr-1" />}
                          {lanc.status === "BAIXADO" && <CheckCircle className="h-3 w-3 mr-1" />}
                          {lanc.status === "ESTORNADO" && <XCircle className="h-3 w-3 mr-1" />}
                          {lanc.status}
                        </Badge>
                        {lanc.data_baixa && <p className="text-xs text-gray-500 mt-0.5">Baixa: {formatDate(lanc.data_baixa)}</p>}
                      </TableCell>
                      <TableCell className="text-right">
                        <div className="flex justify-end gap-1">
                          {lanc.status === "ABERTO" && (
                            <>
                              <Button size="sm" variant="ghost" className="h-7 w-7 p-0 text-green-600 hover:text-green-800" title="Dar Baixa" onClick={() => setShowBaixa(lanc)} data-testid={`btn-baixa-${lanc.id}`}>
                                <CheckCircle className="h-4 w-4" />
                              </Button>
                              <Button size="sm" variant="ghost" className="h-7 w-7 p-0 text-orange-600 hover:text-orange-800" title="Estornar" onClick={() => setShowEstorno(lanc)} data-testid={`btn-estorno-${lanc.id}`}>
                                <RotateCcw className="h-4 w-4" />
                              </Button>
                              <Button size="sm" variant="ghost" className="h-7 w-7 p-0 text-red-500 hover:text-red-700" title="Excluir" onClick={() => excluirLancamento(lanc.id)} data-testid={`btn-excluir-${lanc.id}`}>
                                <Trash2 className="h-4 w-4" />
                              </Button>
                            </>
                          )}
                          {lanc.status === "BAIXADO" && (
                            <Button size="sm" variant="ghost" className="h-7 text-xs text-orange-600 hover:text-orange-800" onClick={() => cancelarBaixaLancamento(lanc.id)} data-testid={`btn-cancelar-baixa-${lanc.id}`}>
                              Cancelar Baixa
                            </Button>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
          {/* Contas Cadastradas */}
          <Card>
            <CardHeader>
              <CardTitle className="text-base flex items-center gap-2"><Building2 className="h-4 w-4" /> Contas Cadastradas</CardTitle>
              <CardDescription>Gerencie as contas para lançamentos</CardDescription>
            </CardHeader>
            <CardContent>
              {gestaoContas.length === 0 ? (
                <div className="text-center py-8 text-muted-foreground">
                  <Building2 className="h-10 w-10 mx-auto mb-2 opacity-30" />
                  <p>Nenhuma conta cadastrada. Crie a primeira conta para começar.</p>
                </div>
              ) : (
                <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
                  {gestaoContas.map(conta => (
                    <div key={conta.id} className="p-3 rounded-lg border bg-white flex items-center justify-between" data-testid={`conta-card-${conta.id}`}>
                      <div>
                        <p className="font-medium text-sm">{conta.nome}</p>
                        <div className="flex gap-2 mt-0.5">
                          <Badge variant="outline" className="text-xs">{conta.tipo}</Badge>
                          {conta.categoria && <Badge variant="outline" className="text-xs bg-gray-50">{conta.categoria}</Badge>}
                        </div>
                      </div>
                      <Button size="sm" variant="ghost" className="h-7 w-7 p-0 text-red-500" onClick={() => excluirConta(conta.id)} title="Excluir">
                        <Trash2 className="h-3 w-3" />
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* ============ Tab: Baixas ============ */}
        <TabsContent value="baixas" className="space-y-4" data-testid="tab-baixas">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <CheckCircle className="h-5 w-5 text-green-600" />
                Baixas (Liquidações)
              </CardTitle>
              <CardDescription>Visualize e gerencie as baixas realizadas nos lançamentos</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="flex flex-wrap items-center gap-3 mb-4 p-3 bg-gray-50 rounded-md border" data-testid="filtro-baixas">
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Centro de Custo:</Label>
                  <Select value={filtroContaLanc} onValueChange={setFiltroContaLanc}>
                    <SelectTrigger className="w-[170px] h-9 bg-white"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      {gestaoContas.map(c => (<SelectItem key={c.id} value={c.id}>{c.nome}</SelectItem>))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Mês:</Label>
                  <Select value={filtroMesLanc} onValueChange={setFiltroMesLanc}>
                    <SelectTrigger className="w-[110px] h-9 bg-white"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      {["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"].map((m, i) => (<SelectItem key={i} value={String(i+1)}>{m}</SelectItem>))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Ano:</Label>
                  <Select value={filtroAnoLanc} onValueChange={setFiltroAnoLanc}>
                    <SelectTrigger className="w-[100px] h-9 bg-white"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      {[0,1,2,3].map(off => { const y = new Date().getFullYear() - off; return (<SelectItem key={y} value={String(y)}>{y}</SelectItem>); })}
                    </SelectContent>
                  </Select>
                </div>
                {(filtroContaLanc !== "todos" || filtroMesLanc !== "todos" || filtroAnoLanc !== "todos") && (
                  <Button variant="ghost" size="sm" className="h-9 text-red-600" onClick={() => { setFiltroContaLanc("todos"); setFiltroMesLanc("todos"); setFiltroAnoLanc("todos"); }}>Limpar Filtros</Button>
                )}
              </div>
              {(() => {
                const lancBaixados = gestaoLancamentos.filter(l => l.status === "BAIXADO" && (filtroContaLanc === "todos" || l.conta_id === filtroContaLanc));
                const lancAbertos = gestaoLancamentos.filter(l => l.status === "ABERTO" && (filtroContaLanc === "todos" || l.conta_id === filtroContaLanc));
                const totalBaixado = lancBaixados.reduce((a, l) => a + l.valor, 0);
                const totalAberto = lancAbertos.reduce((a, l) => a + l.valor, 0);
                return (
                  <>
                    <div className="grid gap-3 md:grid-cols-3 mb-6">
                      <div className="p-3 rounded-lg bg-green-50 border border-green-200">
                        <p className="text-xs text-green-700 font-medium">Total Baixados</p>
                        <p className="text-lg font-bold text-green-700">{formatCurrency(totalBaixado)}</p>
                        <p className="text-xs text-green-600">{lancBaixados.length} lançamento(s)</p>
                      </div>
                      <div className="p-3 rounded-lg bg-yellow-50 border border-yellow-200">
                        <p className="text-xs text-yellow-700 font-medium">Pendentes de Baixa</p>
                        <p className="text-lg font-bold text-yellow-700">{formatCurrency(totalAberto)}</p>
                        <p className="text-xs text-yellow-600">{lancAbertos.length} lançamento(s)</p>
                      </div>
                      <div className="p-3 rounded-lg bg-blue-50 border border-blue-200">
                        <p className="text-xs text-blue-700 font-medium">% Baixado</p>
                        <p className="text-lg font-bold text-blue-700">
                          {totalBaixado + totalAberto > 0 ? ((totalBaixado / (totalBaixado + totalAberto)) * 100).toFixed(1) : 0}%
                        </p>
                      </div>
                    </div>

                    <h4 className="font-semibold text-sm text-yellow-700 mb-3 flex items-center gap-2">
                      <Clock className="h-4 w-4" /> Lançamentos Pendentes de Baixa ({lancAbertos.length})
                    </h4>
                    {lancAbertos.length === 0 ? (
                      <div className="text-center py-8 text-muted-foreground border rounded-lg mb-6">
                        <CheckCircle className="h-10 w-10 mx-auto mb-2 text-green-400" />
                        <p>Todos os lançamentos foram baixados!</p>
                      </div>
                    ) : (
                      <Table>
                        <TableHeader>
                          <TableRow className="bg-yellow-50">
                            <TableHead>Data</TableHead>
                            <TableHead>Tipo</TableHead>
                            <TableHead>Descrição</TableHead>
                            <TableHead>Conta</TableHead>
                            <TableHead className="text-right">Valor</TableHead>
                            <TableHead>Forma Pgto</TableHead>
                            <TableHead className="text-right">Ação</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {lancAbertos.map(lanc => (
                            <TableRow key={lanc.id}>
                              <TableCell className="text-sm">{formatDate(lanc.data)}</TableCell>
                              <TableCell>
                                <Badge className={lanc.tipo === "CREDITO" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}>{lanc.tipo}</Badge>
                              </TableCell>
                              <TableCell className="text-sm">{lanc.descricao}</TableCell>
                              <TableCell className="text-sm">{lanc.conta_nome || "-"}</TableCell>
                              <TableCell className={`text-right font-semibold ${lanc.tipo === "CREDITO" ? "text-green-600" : "text-red-600"}`}>
                                {formatCurrency(lanc.valor)}
                              </TableCell>
                              <TableCell>
                                <Select value={formaPgtoLanc[lanc.id] || "Comissão Recebidas"} onValueChange={(v) => setFormaPgtoLanc({ ...formaPgtoLanc, [lanc.id]: v })}>
                                  <SelectTrigger className="h-8 w-[185px] text-xs" data-testid={`forma-pgto-${lanc.id}`}><SelectValue /></SelectTrigger>
                                  <SelectContent>
                                    <SelectItem value="Comissão Recebidas">Comissão Recebidas</SelectItem>
                                    <SelectItem value="Caixa">Caixa</SelectItem>
                                  </SelectContent>
                                </Select>
                              </TableCell>
                              <TableCell className="text-right">
                                <Button size="sm" className="h-7 text-xs bg-green-600 hover:bg-green-700 gap-1" onClick={() => baixarInline(lanc)} data-testid={`btn-baixa-tab-${lanc.id}`}>
                                  <CheckCircle className="h-3 w-3" /> Dar Baixa
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    )}

                    <Separator className="my-4" />

                    <h4 className="font-semibold text-sm text-green-700 mb-3 flex items-center gap-2">
                      <CheckCircle className="h-4 w-4" /> Lançamentos Baixados ({lancBaixados.length})
                    </h4>
                    {lancBaixados.length === 0 ? (
                      <div className="text-center py-8 text-muted-foreground border rounded-lg">
                        <p>Nenhum lançamento baixado no período</p>
                      </div>
                    ) : (
                      <Table>
                        <TableHeader>
                          <TableRow className="bg-green-50">
                            <TableHead>Data Lanç.</TableHead>
                            <TableHead>Data Baixa</TableHead>
                            <TableHead>Tipo</TableHead>
                            <TableHead>Descrição</TableHead>
                            <TableHead>Conta</TableHead>
                            <TableHead>Forma Pgto</TableHead>
                            <TableHead className="text-right">Valor</TableHead>
                            <TableHead className="text-right">Ação</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {lancBaixados.map(lanc => (
                            <TableRow key={lanc.id}>
                              <TableCell className="text-sm">{formatDate(lanc.data)}</TableCell>
                              <TableCell className="text-sm font-medium">{formatDate(lanc.data_baixa)}</TableCell>
                              <TableCell>
                                <Badge className={lanc.tipo === "CREDITO" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}>{lanc.tipo}</Badge>
                              </TableCell>
                              <TableCell className="text-sm">{lanc.descricao}</TableCell>
                              <TableCell className="text-sm">{lanc.conta_nome || "-"}</TableCell>
                              <TableCell className="text-sm">{lanc.forma_pagamento || "-"}</TableCell>
                              <TableCell className={`text-right font-semibold ${lanc.tipo === "CREDITO" ? "text-green-600" : "text-red-600"}`}>
                                {formatCurrency(lanc.valor)}
                              </TableCell>
                              <TableCell className="text-right">
                                <Button size="sm" variant="ghost" className="h-7 text-xs text-orange-600" onClick={() => cancelarBaixaLancamento(lanc.id)}>
                                  Cancelar
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    )}
                  </>
                );
              })()}
            </CardContent>
          </Card>
        </TabsContent>

        {/* ============ Tab: Saldo de Contas ============ */}
        <TabsContent value="saldo" className="space-y-4" data-testid="tab-saldo">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Wallet className="h-5 w-5 text-purple-600" />
                Centro de Custo
              </CardTitle>
              <CardDescription>Visualização consolidada do saldo por centro de custo</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="flex flex-wrap items-center gap-3 mb-4 p-3 bg-gray-50 rounded-md border" data-testid="filtro-saldo">
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Centro de Custo:</Label>
                  <Select value={filtroContaLanc} onValueChange={setFiltroContaLanc}>
                    <SelectTrigger className="w-[170px] h-9 bg-white"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      {gestaoContas.map(c => (<SelectItem key={c.id} value={c.id}>{c.nome}</SelectItem>))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Mês:</Label>
                  <Select value={filtroMesLanc} onValueChange={setFiltroMesLanc}>
                    <SelectTrigger className="w-[110px] h-9 bg-white"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      {["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"].map((m, i) => (<SelectItem key={i} value={String(i+1)}>{m}</SelectItem>))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Ano:</Label>
                  <Select value={filtroAnoLanc} onValueChange={setFiltroAnoLanc}>
                    <SelectTrigger className="w-[100px] h-9 bg-white"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      {[0,1,2,3].map(off => { const y = new Date().getFullYear() - off; return (<SelectItem key={y} value={String(y)}>{y}</SelectItem>); })}
                    </SelectContent>
                  </Select>
                </div>
                {(filtroContaLanc !== "todos" || filtroMesLanc !== "todos" || filtroAnoLanc !== "todos") && (
                  <Button variant="ghost" size="sm" className="h-9 text-red-600" onClick={() => { setFiltroContaLanc("todos"); setFiltroMesLanc("todos"); setFiltroAnoLanc("todos"); }}>Limpar Filtros</Button>
                )}
              </div>
              {/* Totais Gerais */}
              <div className="grid gap-3 md:grid-cols-3 mb-6">
                <div className="p-4 rounded-lg bg-green-50 border border-green-200">
                  <div className="flex items-center gap-2 text-green-700 mb-1">
                    <ArrowUpRight className="h-4 w-4" />
                    <span className="text-sm font-medium">Total Créditos</span>
                  </div>
                  <p className="text-2xl font-bold text-green-700">{formatCurrency(gestaoSaldo.totais?.total_creditos || 0)}</p>
                </div>
                <div className="p-4 rounded-lg bg-red-50 border border-red-200">
                  <div className="flex items-center gap-2 text-red-700 mb-1">
                    <ArrowDownLeft className="h-4 w-4" />
                    <span className="text-sm font-medium">Total Débitos</span>
                  </div>
                  <p className="text-2xl font-bold text-red-700">{formatCurrency(gestaoSaldo.totais?.total_debitos || 0)}</p>
                </div>
                <div className="p-4 rounded-lg bg-purple-50 border border-purple-200">
                  <div className="flex items-center gap-2 text-purple-700 mb-1">
                    <Wallet className="h-4 w-4" />
                    <span className="text-sm font-medium">Saldo Geral</span>
                  </div>
                  <p className={`text-2xl font-bold ${(gestaoSaldo.totais?.saldo_geral || 0) >= 0 ? "text-purple-700" : "text-red-700"}`}>
                    {formatCurrency(gestaoSaldo.totais?.saldo_geral || 0)}
                  </p>
                </div>
              </div>

              {/* Tabela de Saldos por Conta */}
              {(gestaoSaldo.contas || []).length === 0 ? (
                <div className="text-center py-12 text-muted-foreground border rounded-lg">
                  <Wallet className="h-12 w-12 mx-auto mb-3 opacity-30" />
                  <p className="text-lg font-medium">Nenhuma conta cadastrada</p>
                  <p className="text-sm">Cadastre contas na aba "Lançamentos" para ver o saldo aqui</p>
                </div>
              ) : (
                <Table>
                  <TableHeader>
                    <TableRow className="bg-purple-50">
                      <TableHead>Centro de Custo</TableHead>
                      <TableHead>Tipo</TableHead>
                      <TableHead>Categoria</TableHead>
                      <TableHead className="text-right">Saldo Inicial</TableHead>
                      <TableHead className="text-right text-green-700">Créditos</TableHead>
                      <TableHead className="text-right text-red-700">Débitos</TableHead>
                      <TableHead className="text-right text-amber-700">Baixados</TableHead>
                      <TableHead className="text-right">Saldo Atual</TableHead>
                      <TableHead className="text-center">Lançamentos</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {(gestaoSaldo.contas || []).map(conta => (
                      <TableRow key={conta.conta_id} data-testid={`saldo-row-${conta.conta_id}`}>
                        <TableCell className="font-medium">{conta.conta_nome}</TableCell>
                        <TableCell><Badge variant="outline" className="text-xs">{conta.tipo}</Badge></TableCell>
                        <TableCell className="text-sm text-gray-600">{conta.categoria || "-"}</TableCell>
                        <TableCell className="text-right text-sm">{formatCurrency(conta.saldo_inicial)}</TableCell>
                        <TableCell className="text-right font-semibold text-green-600">{formatCurrency(conta.creditos)}</TableCell>
                        <TableCell className="text-right font-semibold text-red-600">{formatCurrency(conta.debitos)}</TableCell>
                        <TableCell className="text-right font-semibold text-amber-600">{formatCurrency(conta.baixados || 0)}</TableCell>
                        <TableCell className={`text-right font-bold ${conta.saldo >= 0 ? "text-blue-700" : "text-red-700"}`}>
                          {formatCurrency(conta.saldo)}
                        </TableCell>
                        <TableCell className="text-center">
                          <Badge variant="outline">{conta.qtd_lancamentos}</Badge>
                        </TableCell>
                      </TableRow>
                    ))}
                    {/* Linha de Totais */}
                    <TableRow className="bg-purple-100 font-bold">
                      <TableCell colSpan={4} className="text-right">TOTAIS:</TableCell>
                      <TableCell className="text-right text-green-700">{formatCurrency(gestaoSaldo.totais?.total_creditos || 0)}</TableCell>
                      <TableCell className="text-right text-red-700">{formatCurrency(gestaoSaldo.totais?.total_debitos || 0)}</TableCell>
                      <TableCell className="text-right text-amber-700">{formatCurrency(gestaoSaldo.totais?.total_baixados || 0)}</TableCell>
                      <TableCell className="text-right text-purple-700">{formatCurrency(gestaoSaldo.totais?.saldo_geral || 0)}</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* Tab: Dashboard */}
        <TabsContent value="dashboard" className="space-y-4">
          <div className="grid gap-4 md:grid-cols-2">
            {/* Últimas Transações */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Últimas Transações</CardTitle>
                <CardDescription>Movimentações recentes</CardDescription>
              </CardHeader>
              <CardContent>
                <ScrollArea className="h-[300px]">
                  <div className="space-y-3">
                    {transacoes.slice(0, 5).map((t) => (
                      <div key={t.id} className="flex items-center justify-between p-3 rounded-lg bg-slate-50">
                        <div className="flex items-center gap-3">
                          <div className={`p-2 rounded-full ${t.tipo === "RECEITA" ? "bg-green-100" : "bg-red-100"}`}>
                            {t.tipo === "RECEITA" ? (
                              <ArrowUpRight className={`h-4 w-4 text-green-600`} />
                            ) : (
                              <ArrowDownLeft className={`h-4 w-4 text-red-600`} />
                            )}
                          </div>
                          <div>
                            <p className="font-medium text-sm">{t.descricao}</p>
                            <p className="text-xs text-gray-500">{t.categoria} • {formatDate(t.data)}</p>
                          </div>
                        </div>
                        <span className={`font-semibold ${t.tipo === "RECEITA" ? "text-green-600" : "text-red-600"}`}>
                          {t.tipo === "RECEITA" ? "+" : "-"}{formatCurrency(t.valor)}
                        </span>
                      </div>
                    ))}
                  </div>
                </ScrollArea>
              </CardContent>
            </Card>

            {/* Comissões Pendentes */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Comissões - Pendente Recebimento</CardTitle>
                <CardDescription>Aguardando recebimento do banco</CardDescription>
              </CardHeader>
              <CardContent>
                <ScrollArea className="h-[300px]">
                  <div className="space-y-3">
                    {comissoes.filter(c => c.status === "PENDENTE_RECEBIMENTO" || c.status_recebimento === "PENDENTE" || c.status === "PENDENTE").length === 0 ? (
                      <div className="text-center text-muted-foreground py-8">
                        Nenhuma comissão pendente de recebimento
                      </div>
                    ) : comissoes.filter(c => c.status === "PENDENTE_RECEBIMENTO" || c.status_recebimento === "PENDENTE" || c.status === "PENDENTE").map((c) => (
                      <div key={c.id} className="flex items-center justify-between p-3 rounded-lg bg-orange-50 border border-orange-200">
                        <div>
                          <p className="font-medium text-sm">{c.operador || c.vendedor || c.corretor || "-"}</p>
                          <p className="text-xs text-gray-500">{c.cliente_nome || c.cliente || "-"} • {c.numero_contrato || c.contrato || "-"}</p>
                          <p className="text-xs text-gray-400">{c.tipo_operacao || "-"}</p>
                        </div>
                        <div className="text-right">
                          <span className="font-semibold text-orange-700">{formatCurrency(c.valor_empresa || c.valor)}</span>
                          <p className="text-xs text-gray-500">{formatDate(c.data)}</p>
                          <Button 
                            size="sm" 
                            className="h-6 text-xs mt-1 bg-green-600 hover:bg-green-700"
                            onClick={() => receberComissao(c.id)}
                          >
                            Recebido
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                </ScrollArea>
              </CardContent>
            </Card>
          </div>
        </TabsContent>

        {/* Tab: Comissões */}
        <TabsContent value="comissoes" className="space-y-4">
          {/* Seção 1: Comissões Pendentes de Recebimento (do Banco) */}
          <Card>
            <CardHeader className="flex flex-row items-center justify-between bg-orange-50">
              <div>
                <CardTitle className="flex items-center gap-2">
                  <Clock className="h-5 w-5 text-orange-600" />
                  Pendentes de Recebimento
                </CardTitle>
                <CardDescription>Comissões que a empresa precisa receber do banco</CardDescription>
              </div>
              <Badge variant="outline" className="text-orange-600 border-orange-600">
                {comissoes.filter(c => c.status === "PENDENTE_RECEBIMENTO" || c.status_recebimento === "PENDENTE").length} pendentes
              </Badge>
            </CardHeader>
            <CardContent className="pt-4">
              {/* Filtros */}
              <div className="flex flex-wrap gap-3 mb-4 p-3 bg-gray-50 rounded-lg">
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Banco:</Label>
                  <Select value={filtroBanco} onValueChange={setFiltroBanco}>
                    <SelectTrigger className="w-[180px] h-9 bg-white">
                      <SelectValue placeholder="Todos" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      {[...new Set(comissoes.filter(c => c.status === "PENDENTE_RECEBIMENTO" || c.status_recebimento === "PENDENTE").map(c => c.banco_nome || c.banco_codigo).filter(Boolean))].map(banco => (
                        <SelectItem key={banco} value={banco}>{banco}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Correspondente:</Label>
                  <Select value={filtroCorrespondente} onValueChange={setFiltroCorrespondente}>
                    <SelectTrigger className="w-[180px] h-9 bg-white">
                      <SelectValue placeholder="Todos" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      {[...new Set(comissoes.filter(c => c.status === "PENDENTE_RECEBIMENTO" || c.status_recebimento === "PENDENTE").map(c => c.correspondente).filter(Boolean))].map(corresp => (
                        <SelectItem key={corresp} value={corresp}>{corresp}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center gap-2">
                  <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Tipo Operação:</Label>
                  <Select value={filtroTipoOperacao} onValueChange={setFiltroTipoOperacao}>
                    <SelectTrigger className="w-[180px] h-9 bg-white">
                      <SelectValue placeholder="Todos" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="todos">Todos</SelectItem>
                      {[...new Set(comissoes.filter(c => c.status === "PENDENTE_RECEBIMENTO" || c.status_recebimento === "PENDENTE").map(c => c.tipo_operacao).filter(Boolean))].map(tipo => (
                        <SelectItem key={tipo} value={tipo}>{tipo}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                {(filtroBanco !== "todos" || filtroCorrespondente !== "todos" || filtroTipoOperacao !== "todos") && (
                  <Button 
                    variant="ghost" 
                    size="sm" 
                    className="h-9 text-red-600 hover:text-red-700 hover:bg-red-50"
                    onClick={() => {
                      setFiltroBanco("todos");
                      setFiltroCorrespondente("todos");
                      setFiltroTipoOperacao("todos");
                    }}
                  >
                    Limpar Filtros
                  </Button>
                )}
                
                {/* Busca por CPF/Contrato */}
                <div className="flex items-center gap-2 ml-auto">
                  <div className="relative">
                    <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-gray-400" />
                    <Input
                      placeholder="Buscar CPF ou Contrato..."
                      value={buscaComissao}
                      onChange={(e) => setBuscaComissao(e.target.value)}
                      className="pl-8 h-9 w-[220px] text-sm"
                      data-testid="busca-comissao-input"
                    />
                  </div>
                </div>

                {/* Botao Exportar Excel das Pendentes */}
                <div>
                  <Button
                    variant="outline"
                    size="sm"
                    className="h-9 bg-blue-50 border-blue-300 text-blue-700 hover:bg-blue-100 hover:text-blue-800"
                    data-testid="exportar-pendentes-excel-btn"
                    onClick={() => {
                      const params = new URLSearchParams();
                      if (filtroBanco && filtroBanco !== "todos") params.append("banco", filtroBanco);
                      if (filtroCorrespondente && filtroCorrespondente !== "todos") params.append("correspondente", filtroCorrespondente);
                      if (filtroTipoOperacao && filtroTipoOperacao !== "todos") params.append("tipo_operacao", filtroTipoOperacao);
                      if (buscaComissao) params.append("busca", buscaComissao);
                      const url = `${API}/financeiro/comissoes-pendentes/exportar-excel${params.toString() ? "?" + params.toString() : ""}`;
                      window.open(url, "_blank");
                    }}
                  >
                    <FileSpreadsheet className="h-4 w-4 mr-2" />
                    Exportar Excel
                  </Button>
                </div>

                {/* Botão Importar Relatório do Banco */}
                <div>
                  <Button 
                    variant="outline"
                    size="sm"
                    className="h-9 bg-green-50 border-green-300 text-green-700 hover:bg-green-100 hover:text-green-800"
                    onClick={() => setShowImportarRelatorioBanco(true)}
                  >
                    <Upload className="h-4 w-4 mr-2" />
                    Importar Relatório do Banco
                  </Button>
                </div>
              </div>
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Operador</TableHead>
                    <TableHead>Cliente</TableHead>
                    <TableHead>Nº Contrato</TableHead>
                    <TableHead>Banco/Tipo</TableHead>
                    <TableHead>Valor Contrato</TableHead>
                    <TableHead>Comissão Esperada</TableHead>
                    <TableHead>Comissão Recebida</TableHead>
                    <TableHead>Diferença</TableHead>
                    <TableHead>Corretor</TableHead>
                    <TableHead>Atendente</TableHead>
                    <TableHead>Ger. Adm</TableHead>
                    <TableHead>Data/Tempo</TableHead>
                    <TableHead>Imposto</TableHead>
                    <TableHead>Lucro Líquido</TableHead>
                    <TableHead className="text-right">Ações</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {comissoes
                    .filter(c => c.status === "PENDENTE_RECEBIMENTO" || c.status_recebimento === "PENDENTE")
                    .filter(c => filtroBanco === "todos" || (c.banco_nome || c.banco_codigo) === filtroBanco)
                    .filter(c => filtroCorrespondente === "todos" || c.correspondente === filtroCorrespondente)
                    .filter(c => filtroTipoOperacao === "todos" || c.tipo_operacao === filtroTipoOperacao)
                    .filter(c => 
                      (c.vendedor || c.operador || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
                      (c.cliente_nome || "").toLowerCase().includes(searchTerm.toLowerCase())
                    )
                    .filter(c => {
                      if (!buscaComissao) return true;
                      const termo = buscaComissao.toLowerCase().trim();
                      return (
                        (c.numero_contrato || "").toLowerCase().includes(termo) ||
                        (c.cliente_cpf || "").toLowerCase().replace(/[.-]/g, "").includes(termo.replace(/[.-]/g, "")) ||
                        (c.cliente_nome || "").toLowerCase().includes(termo)
                      );
                    }).length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={15} className="h-24 text-center text-muted-foreground">
                        Nenhuma comissão pendente de recebimento
                      </TableCell>
                    </TableRow>
                  ) : comissoes
                    .filter(c => c.status === "PENDENTE_RECEBIMENTO" || c.status_recebimento === "PENDENTE")
                    .filter(c => filtroBanco === "todos" || (c.banco_nome || c.banco_codigo) === filtroBanco)
                    .filter(c => filtroCorrespondente === "todos" || c.correspondente === filtroCorrespondente)
                    .filter(c => filtroTipoOperacao === "todos" || c.tipo_operacao === filtroTipoOperacao)
                    .filter(c => 
                      (c.vendedor || c.operador || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
                      (c.cliente_nome || "").toLowerCase().includes(searchTerm.toLowerCase())
                    )
                    .filter(c => {
                      if (!buscaComissao) return true;
                      const termo = buscaComissao.toLowerCase().trim();
                      return (
                        (c.numero_contrato || "").toLowerCase().includes(termo) ||
                        (c.cliente_cpf || "").toLowerCase().replace(/[.-]/g, "").includes(termo.replace(/[.-]/g, "")) ||
                        (c.cliente_nome || "").toLowerCase().includes(termo)
                      );
                    })
                    .map((comissao) => {
                      // Formatar operador: código + primeiro nome
                      const operadorCompleto = comissao.operador || comissao.vendedor || "-";
                      const partesOperador = operadorCompleto.trim().split(" ");
                      const operadorFormatado = partesOperador.length >= 2 
                        ? `${partesOperador[0]} ${partesOperador[1]}` 
                        : operadorCompleto;
                      
                      // Determinar função do operador - usar perfil_operador que vem do backend
                      // Prioridade: perfil_operador > funcao_operador
                      const funcaoOperador = comissao.perfil_operador || comissao.funcao_operador || "Atendente";
                      const isCorretor = funcaoOperador.toUpperCase() === "CORRETOR";
                      const isAtendente = funcaoOperador.toUpperCase() === "ATENDENTE";
                      
                      // REGRA DE COMISSÃO:
                      // Se operador é ATENDENTE -> Corretor ganha ZERO
                      // Se operador é CORRETOR -> Atendente ganha ZERO
                      const valorCorretor = isAtendente ? 0 : (comissao.valor_corretor || 0);
                      const valorAtendente = isCorretor ? 0 : (comissao.valor_atendente || 0);
                      const percentualCorretor = isAtendente ? 0 : (comissao.percentual_corretor || 30);
                      const percentualAtendente = isCorretor ? 0 : (comissao.percentual_atendente || 5);
                      
                      // Calcular tempo pendente
                      const dataAprovacao = comissao.data ? new Date(comissao.data) : null;
                      let tempoPendente = "";
                      if (dataAprovacao) {
                        const agora = new Date();
                        const diffMs = agora - dataAprovacao;
                        const diffDias = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                        const diffHoras = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        if (diffDias > 0) {
                          tempoPendente = `${diffDias}d ${diffHoras}h`;
                        } else {
                          tempoPendente = `${diffHoras}h`;
                        }
                      }
                      
                      // Calcular diferença entre esperada e recebida
                      const comissaoEsperada = comissao.valor_empresa || comissao.valor || 0;
                      const comissaoRecebida = comissao.valor_recebido || 0;
                      const diferenca = comissaoRecebida - comissaoEsperada;
                      
                      // REGRA: Se Comissão Recebida ≠ Comissão Esperada → usar Recebida como base
                      // Se igual ou não preenchida → usar Esperada como base
                      const baseCalculo = (comissaoRecebida > 0 && comissaoRecebida !== comissaoEsperada) 
                        ? comissaoRecebida 
                        : comissaoEsperada;
                      
                      // Recalcular valores de comissões baseado na nova base
                      const valorCorretorCalculado = isAtendente ? 0 : (baseCalculo * percentualCorretor) / 100;
                      const valorAtendenteCalculado = isCorretor ? 0 : (baseCalculo * percentualAtendente) / 100;
                      const valorGerAdmCalculado = (baseCalculo * (comissao.percentual_ger_adm || 10)) / 100;
                      
                      // Calcular percentual da comissão recebida
                      const valorContrato = comissao.valor_contrato || 0;
                      const percentualRecebido = valorContrato > 0 ? ((comissaoRecebida / valorContrato) * 100).toFixed(2) : 0;
                      
                      // Calcular imposto (padrão 15% sobre a base de cálculo)
                      const percentualImposto = comissao.percentual_imposto || 15;
                      const valorImposto = baseCalculo > 0 ? (baseCalculo * percentualImposto) / 100 : 0;
                      
                      // Calcular lucro líquido usando valores calculados
                      const totalOperadores = valorCorretorCalculado + valorAtendenteCalculado + valorGerAdmCalculado;
                      const lucroLiquido = baseCalculo > 0 ? baseCalculo - totalOperadores - valorImposto : 0;
                      
                      return (
                        <TableRow key={comissao.id} className="bg-orange-50/50">
                          <TableCell>
                            <div>
                              <p className="font-medium text-sm">{operadorFormatado}</p>
                              <Badge variant="outline" className={`text-xs mt-0.5 ${isCorretor ? 'bg-yellow-50 text-yellow-700' : 'bg-orange-50 text-orange-700'}`}>
                                {funcaoOperador.toUpperCase()}
                              </Badge>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div>
                              <p className="font-medium text-sm">{comissao.cliente_nome || "-"}</p>
                              <p className="text-xs text-gray-500">{comissao.cliente_cpf || "-"}</p>
                              {comissao.instituicao && (
                                <p className="text-xs text-blue-600">{comissao.instituicao}</p>
                              )}
                              {comissao.correspondente && (
                                <p className="text-xs text-purple-600 font-medium">{comissao.correspondente}</p>
                              )}
                            </div>
                          </TableCell>
                          <TableCell className="font-mono text-sm font-semibold">{comissao.numero_contrato || "-"}</TableCell>
                          <TableCell>
                            <div>
                              <Badge variant="outline" className="text-xs">{comissao.banco_nome || comissao.banco_codigo || "-"}</Badge>
                              <p className="text-xs text-gray-500 mt-0.5">{comissao.tipo_operacao || "-"}</p>
                              {comissao.produto_nome && (
                                <p className="text-xs text-green-600 mt-0.5">{comissao.produto_nome}</p>
                              )}
                            </div>
                          </TableCell>
                          <TableCell className="font-semibold">{formatCurrency(comissao.valor_contrato)}</TableCell>
                          <TableCell>
                            <div className="text-center">
                              <Badge variant="outline" className="bg-blue-50 text-blue-700 text-xs">
                                {comissao.percentual_empresa || 9.5}%
                              </Badge>
                              <p className="font-semibold text-blue-700 mt-0.5">{formatCurrency(comissaoEsperada)}</p>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="text-center">
                              <Badge variant="outline" className="bg-green-50 text-green-700 text-xs mb-0.5">
                                {percentualRecebido}%
                              </Badge>
                              <Input 
                                type="text"
                                placeholder="0,00"
                                className="w-28 h-8 text-xs text-center"
                                defaultValue={comissaoRecebida > 0 ? comissaoRecebida.toFixed(2).replace('.', ',') : ""}
                                onBlur={(e) => {
                                  // Converter formato brasileiro para número (remove TODOS os separadores de milhar)
                                  const valorStr = e.target.value.trim().replace(/\./g, '').replace(',', '.');
                                  const valor = parseFloat(valorStr) || 0;
                                  if (Math.abs(valor - comissaoRecebida) > 0.001) {
                                    atualizarValorRecebido(comissao.id, valor);
                                  }
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="text-center">
                              {comissaoRecebida > 0 ? (
                                <p className={`font-semibold ${diferenca === 0 ? 'text-green-700' : diferenca > 0 ? 'text-green-700' : 'text-red-700'}`}>
                                  {diferenca === 0 ? 'OK' : formatCurrency(diferenca)}
                                </p>
                              ) : (
                                <p className="text-gray-400 text-xs">-</p>
                              )}
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="text-center">
                              <span className="text-xs text-gray-500">{percentualCorretor}%</span>
                              <p className={`font-semibold ${valorCorretorCalculado === 0 ? 'text-gray-400' : 'text-yellow-700'}`}>
                                {formatCurrency(valorCorretorCalculado)}
                              </p>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="text-center">
                              <span className="text-xs text-gray-500">{percentualAtendente}%</span>
                              <p className={`font-semibold ${valorAtendenteCalculado === 0 ? 'text-gray-400' : 'text-orange-700'}`}>
                                {formatCurrency(valorAtendenteCalculado)}
                              </p>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="text-center">
                              <span className="text-xs text-gray-500">{comissao.percentual_ger_adm || 10}%</span>
                              <p className="font-semibold text-purple-700">{formatCurrency(valorGerAdmCalculado)}</p>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="text-center">
                              <p className="text-sm font-medium">{formatDate(comissao.data)}</p>
                              <Badge variant="outline" className="text-xs bg-red-50 text-red-700 mt-0.5">
                                {tempoPendente}
                              </Badge>
                              {comissao.data_recebimento && (
                                <p className="text-xs text-green-600 mt-1">
                                  Receb: {formatDate(comissao.data_recebimento)}
                                </p>
                              )}
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="text-center">
                              <span className="text-xs text-gray-500">{percentualImposto}%</span>
                              <p className="font-semibold text-red-600">{baseCalculo > 0 ? formatCurrency(valorImposto) : '-'}</p>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="text-center">
                              <p className={`font-semibold ${lucroLiquido >= 0 ? 'text-green-700' : 'text-red-700'}`}>
                                {baseCalculo > 0 ? formatCurrency(lucroLiquido) : '-'}
                              </p>
                            </div>
                          </TableCell>
                          <TableCell className="text-right">
                            <Button 
                              size="sm" 
                              className="h-8 gap-1 bg-yellow-500 hover:bg-yellow-600 text-xs"
                              onClick={() => receberComissao(comissao.id)}
                            >
                              <CheckCircle className="h-3 w-3" />
                              Baixar Recebimento
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Tab: Pendente Comissão Equipe */}
        <TabsContent value="comissoes_equipe" className="space-y-4">
          {(() => {
            // Agrupar comissões pendentes por operador
            const comissoesPendentes = comissoes.filter(c => c.status === "PENDENTE_PAGAMENTO" || c.status_pagamento === "PENDENTE");
            
            // Criar mapa de operadores (Corretor/Atendente) com suas comissões
            const operadoresMap = {};
            comissoesPendentes.forEach(comissao => {
              const operadorKey = comissao.operador || comissao.vendedor || "Sem Operador";
              if (!operadoresMap[operadorKey]) {
                operadoresMap[operadorKey] = {
                  nome: operadorKey,
                  perfil: comissao.perfil_operador || "ATENDENTE",
                  comissoes: []
                };
              }
              operadoresMap[operadorKey].comissoes.push(comissao);
            });
            
            const operadoresList = Object.values(operadoresMap);
            
            // Calcular totais gerais para operadores (Corretor/Atendente)
            const totalGeralOperadores = comissoesPendentes.reduce((acc, c) => {
              const base = c.valor_recebido || c.valor_empresa || 0;
              const isAtendente = (c.perfil_operador || "ATENDENTE").toUpperCase() === "ATENDENTE";
              const isCorretor = (c.perfil_operador || "").toUpperCase() === "CORRETOR";
              const valorOperador = isAtendente 
                ? (base * (c.percentual_atendente || 5)) / 100 
                : isCorretor 
                  ? (base * (c.percentual_corretor || 30)) / 100 
                  : 0;
              return acc + valorOperador;
            }, 0);
            
            // Calcular total para Ger. Adm (recebe de TODAS as comissões)
            const totalGerAdm = comissoesPendentes.reduce((acc, c) => {
              const base = c.valor_recebido || c.valor_empresa || 0;
              return acc + (base * (c.percentual_ger_adm || 10)) / 100;
            }, 0);
            
            return (
              <>
                {/* Header com totais */}
                <Card>
                  <CardHeader className="flex flex-row items-center justify-between bg-yellow-50">
                    <div>
                      <CardTitle className="flex items-center gap-2">
                        <CircleDollarSign className="h-5 w-5 text-yellow-600" />
                        Pendentes de Pagamento - Equipe
                      </CardTitle>
                      <CardDescription>Comissões a pagar para operadores (Corretor, Atendente, Gerente Adm.)</CardDescription>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="text-sm text-gray-600">Total Operadores:</span>
                      <Badge variant="outline" className="text-yellow-600 border-yellow-600 text-lg px-3 py-1">
                        {formatCurrency(totalGeralOperadores)}
                      </Badge>
                      <span className="text-sm text-gray-600">Total Ger. Adm:</span>
                      <Badge variant="outline" className="text-purple-600 border-purple-600 text-lg px-3 py-1">
                        {formatCurrency(totalGerAdm)}
                      </Badge>
                      <Badge variant="outline" className="text-yellow-600 border-yellow-600">
                        {comissoesPendentes.length} pendentes
                      </Badge>
                    </div>
                  </CardHeader>
                </Card>
                
                {/* === SEÇÃO: CORRETOR / ATENDENTE === */}
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-gray-700 flex items-center gap-2">
                    <Users className="h-5 w-5" />
                    Corretor / Atendente
                  </h3>
                  
                  {operadoresList.length === 0 ? (
                    <Card>
                      <CardContent className="h-24 flex items-center justify-center text-muted-foreground">
                        Nenhuma comissão pendente para operadores
                      </CardContent>
                    </Card>
                  ) : (
                    operadoresList.map((operador) => {
                      const partesNome = operador.nome.trim().split(" ");
                      const codigoOperador = partesNome[0] || "";
                      const nomeOperador = partesNome.slice(1).join(" ") || operador.nome;
                      const isCorretor = operador.perfil.toUpperCase() === "CORRETOR";
                      const isAtendente = operador.perfil.toUpperCase() === "ATENDENTE";
                      
                      let totalComissaoOperador = 0;
                      operador.comissoes.forEach(c => {
                        const base = c.valor_recebido || c.valor_empresa || 0;
                        if (isAtendente) {
                          totalComissaoOperador += (base * (c.percentual_atendente || 5)) / 100;
                        } else if (isCorretor) {
                          totalComissaoOperador += (base * (c.percentual_corretor || 30)) / 100;
                        }
                      });
                      
                      return (
                        <Card key={operador.nome} className={`border-l-4 ${isCorretor ? 'border-l-yellow-500' : 'border-l-orange-500'}`}>
                          <CardHeader 
                            className={`bg-gradient-to-r ${isCorretor ? 'from-yellow-50' : 'from-orange-50'} to-white cursor-pointer select-none`}
                            onClick={() => setExpandedOperadores(prev => ({...prev, [operador.nome]: !prev[operador.nome]}))}
                          >
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-3">
                                <div className={`w-12 h-12 rounded-full flex items-center justify-center ${isCorretor ? 'bg-yellow-100' : 'bg-orange-100'}`}>
                                  <Users className={`h-6 w-6 ${isCorretor ? 'text-yellow-700' : 'text-orange-700'}`} />
                                </div>
                                <div>
                                  <CardTitle className="text-lg flex items-center gap-2">
                                    {nomeOperador}
                                    <Badge variant="outline" className={`text-xs ${isCorretor ? 'bg-yellow-100 text-yellow-700' : 'bg-orange-100 text-orange-700'}`}>
                                      {operador.perfil}
                                    </Badge>
                                  </CardTitle>
                                  <CardDescription>Código: {codigoOperador} • {operador.comissoes.length} contrato(s)</CardDescription>
                                </div>
                              </div>
                              <div className="flex items-center gap-4">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Comissão a Receber</p>
                                  <p className={`text-xl font-bold ${isCorretor ? 'text-yellow-700' : 'text-orange-700'}`}>{formatCurrency(totalComissaoOperador)}</p>
                                </div>
                                <ChevronDown className={`h-5 w-5 text-gray-400 transition-transform ${expandedOperadores[operador.nome] ? 'rotate-180' : ''}`} />
                              </div>
                            </div>
                          </CardHeader>
                          {expandedOperadores[operador.nome] && (
                          <CardContent className="pt-4">
                            <div className="flex justify-end gap-2 mb-3">
                              <Button 
                                size="sm" 
                                className="gap-1 bg-green-600 hover:bg-green-700"
                                onClick={(e) => { e.stopPropagation(); operador.comissoes.forEach(c => pagarComissao(c.id)); }}
                              >
                                <DollarSign className="h-4 w-4" />
                                Pagar Tudo
                              </Button>
                              <Button 
                                size="sm" 
                                variant="outline"
                                className="gap-1"
                                onClick={(e) => { e.stopPropagation(); gerarPDFOperadorPendente(operador, operador.comissoes); }}
                              >
                                <Download className="h-4 w-4" />
                                Baixar
                              </Button>
                            </div>
                            <Table>
                              <TableHeader>
                                <TableRow className="bg-gray-50">
                                  <TableHead>Cliente</TableHead>
                                  <TableHead>Nº Contrato</TableHead>
                                  <TableHead>Banco/Tipo</TableHead>
                                  <TableHead>Valor Contrato</TableHead>
                                  <TableHead>Comissão {operador.perfil}</TableHead>
                                  <TableHead>Data Receb.</TableHead>
                                  <TableHead>Status</TableHead>
                                  <TableHead className="text-right">Ação</TableHead>
                                </TableRow>
                              </TableHeader>
                              <TableBody>
                                {operador.comissoes.map((comissao) => {
                                  const baseCalculo = comissao.valor_recebido || comissao.valor_empresa || 0;
                                  const percentualOperador = isAtendente 
                                    ? (comissao.percentual_atendente || 5) 
                                    : (comissao.percentual_corretor || 30);
                                  const valorOperador = (baseCalculo * percentualOperador) / 100;
                                  
                                  return (
                                    <TableRow key={comissao.id}>
                                      <TableCell>
                                        <div>
                                          <p className="font-medium text-sm">{comissao.cliente_nome || "-"}</p>
                                          <p className="text-xs text-gray-500">{comissao.cliente_cpf || "-"}</p>
                                          {comissao.correspondente && (
                                            <p className="text-xs text-purple-600">{comissao.correspondente}</p>
                                          )}
                                        </div>
                                      </TableCell>
                                      <TableCell className="font-mono text-sm">{comissao.numero_contrato || "-"}</TableCell>
                                      <TableCell>
                                        <div>
                                          <Badge variant="outline" className="text-xs">{comissao.banco_nome || "-"}</Badge>
                                          <p className="text-xs text-gray-500 mt-0.5">{comissao.tipo_operacao || "-"}</p>
                                        </div>
                                      </TableCell>
                                      <TableCell className="font-semibold">{formatCurrency(comissao.valor_contrato)}</TableCell>
                                      <TableCell>
                                        <div className="text-center">
                                          <span className="text-xs text-gray-500">{percentualOperador}%</span>
                                          <p className={`font-bold ${isCorretor ? 'text-yellow-700' : 'text-orange-700'}`}>{formatCurrency(valorOperador)}</p>
                                        </div>
                                      </TableCell>
                                      <TableCell className="text-sm">{formatDate(comissao.data_recebimento)}</TableCell>
                                      <TableCell>
                                        <Badge className="bg-yellow-100 text-yellow-800 gap-1">
                                          <Clock className="h-3 w-3" />
                                          Pendente
                                        </Badge>
                                      </TableCell>
                                      <TableCell className="text-right">
                                        <Button 
                                          size="sm" 
                                          variant="outline"
                                          className="h-7 gap-1 text-green-600 border-green-600 hover:bg-green-50"
                                          onClick={() => pagarComissao(comissao.id)}
                                        >
                                          <CheckCircle className="h-3 w-3" />
                                          Pagar
                                        </Button>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                                <TableRow className="bg-gray-100 font-bold">
                                  <TableCell colSpan={4} className="text-right">Total {nomeOperador}:</TableCell>
                                  <TableCell className={`text-center ${isCorretor ? 'text-yellow-700' : 'text-orange-700'}`}>
                                    {formatCurrency(totalComissaoOperador)}
                                  </TableCell>
                                  <TableCell colSpan={3}></TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </CardContent>
                          )}
                        </Card>
                      );
                    })
                  )}
                </div>
                
                {/* === SEÇÃO: GERENTE ADMINISTRATIVO === */}
                <div className="space-y-4 mt-6">
                  <h3 className="text-lg font-semibold text-purple-700 flex items-center gap-2">
                    <CircleDollarSign className="h-5 w-5" />
                    Gerente Administrativo
                  </h3>
                  
                  {comissoesPendentes.length === 0 ? (
                    <Card>
                      <CardContent className="h-24 flex items-center justify-center text-muted-foreground">
                        Nenhuma comissao pendente para Ger. Adm
                      </CardContent>
                    </Card>
                  ) : (() => {
                    let totalGerAdmClaudio = 0;
                    comissoesPendentes.forEach(c => {
                      const base = c.valor_recebido || c.valor_empresa || 0;
                      totalGerAdmClaudio += (base * (c.percentual_ger_adm || 10)) / 100;
                    });
                    
                    return (
                        <Card className="border-l-4 border-l-purple-500">
                          <CardHeader 
                            className="bg-gradient-to-r from-purple-50 to-white cursor-pointer select-none"
                            onClick={() => setExpandedOperadores(prev => ({...prev, ["geradm-claudio"]: !prev["geradm-claudio"]}))}
                          >
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-3">
                                <div className="w-12 h-12 rounded-full flex items-center justify-center bg-purple-100">
                                  <CircleDollarSign className="h-6 w-6 text-purple-700" />
                                </div>
                                <div>
                                  <CardTitle className="text-lg flex items-center gap-2">
                                    CLAUDIO DOMINGOS DE FIGUEIREDO JUNIOR
                                    <Badge variant="outline" className="text-xs bg-purple-100 text-purple-700">
                                      G. ADMIN
                                    </Badge>
                                  </CardTitle>
                                  <CardDescription>Codigo: PA0001 - {comissoesPendentes.length} contrato(s)</CardDescription>
                                </div>
                              </div>
                              <div className="flex items-center gap-4">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Comissao a Receber</p>
                                  <p className="text-xl font-bold text-purple-700">{formatCurrency(totalGerAdmClaudio)}</p>
                                </div>
                                <ChevronDown className={`h-5 w-5 text-gray-400 transition-transform ${expandedOperadores["geradm-claudio"] ? 'rotate-180' : ''}`} />
                              </div>
                            </div>
                          </CardHeader>
                          {expandedOperadores["geradm-claudio"] && (
                          <CardContent className="pt-4">
                            <div className="flex justify-end gap-2 mb-3">
                              <Button 
                                size="sm" 
                                className="gap-1 bg-purple-600 hover:bg-purple-700"
                                onClick={(e) => { e.stopPropagation(); comissoesPendentes.forEach(c => pagarComissao(c.id)); }}
                              >
                                <DollarSign className="h-4 w-4" />
                                Pagar Tudo
                              </Button>
                              <Button 
                                size="sm" 
                                variant="outline"
                                className="gap-1 border-purple-600 text-purple-600"
                                onClick={(e) => { e.stopPropagation(); gerarPDFGerAdmPendente(comissoesPendentes); }}
                              >
                                <Download className="h-4 w-4" />
                                Baixar
                              </Button>
                            </div>
                            <Table>
                              <TableHeader>
                                <TableRow className="bg-purple-50">
                                  <TableHead>Operador</TableHead>
                                  <TableHead>Cliente</TableHead>
                                  <TableHead>Nr Contrato</TableHead>
                                  <TableHead>Banco/Tipo</TableHead>
                                  <TableHead>Valor Contrato</TableHead>
                                  <TableHead>Comissao Ger. Adm</TableHead>
                                  <TableHead>Data Receb.</TableHead>
                                  <TableHead>Status</TableHead>
                                  <TableHead className="text-right">Acao</TableHead>
                                </TableRow>
                              </TableHeader>
                              <TableBody>
                                {comissoesPendentes.map((comissao) => {
                                  const baseCalculo = comissao.valor_recebido || comissao.valor_empresa || 0;
                                  const valorGerAdm = (baseCalculo * (comissao.percentual_ger_adm || 10)) / 100;
                                  const opVinculado = comissao.operador || comissao.vendedor || "-";
                                  const partesOp = opVinculado.trim().split(" ");
                                  const opFmt = partesOp.length >= 2 ? `${partesOp[0]} ${partesOp[1]}` : opVinculado;
                                  
                                  return (
                                    <TableRow key={`ga-${comissao.id}`}>
                                      <TableCell>
                                        <div>
                                          <p className="font-medium text-sm">{opFmt}</p>
                                          <Badge variant="outline" className="text-xs bg-gray-50">{comissao.perfil_operador || "ATENDENTE"}</Badge>
                                        </div>
                                      </TableCell>
                                      <TableCell>
                                        <div>
                                          <p className="font-medium text-sm">{comissao.cliente_nome || "-"}</p>
                                          <p className="text-xs text-gray-500">{comissao.cliente_cpf || "-"}</p>
                                          {comissao.correspondente && (
                                            <p className="text-xs text-purple-600">{comissao.correspondente}</p>
                                          )}
                                        </div>
                                      </TableCell>
                                      <TableCell className="font-mono text-sm">{comissao.numero_contrato || "-"}</TableCell>
                                      <TableCell>
                                        <div>
                                          <Badge variant="outline" className="text-xs">{comissao.banco_nome || "-"}</Badge>
                                          <p className="text-xs text-gray-500 mt-0.5">{comissao.tipo_operacao || "-"}</p>
                                        </div>
                                      </TableCell>
                                      <TableCell className="font-semibold">{formatCurrency(comissao.valor_contrato)}</TableCell>
                                      <TableCell>
                                        <div className="text-center">
                                          <span className="text-xs text-gray-500">{comissao.percentual_ger_adm || 10}%</span>
                                          <p className="font-bold text-purple-700">{formatCurrency(valorGerAdm)}</p>
                                        </div>
                                      </TableCell>
                                      <TableCell className="text-sm">{formatDate(comissao.data_recebimento)}</TableCell>
                                      <TableCell>
                                        <Badge className="bg-purple-100 text-purple-800 gap-1">
                                          <Clock className="h-3 w-3" />
                                          Pendente
                                        </Badge>
                                      </TableCell>
                                      <TableCell className="text-right">
                                        <Button 
                                          size="sm" 
                                          variant="outline"
                                          className="h-7 gap-1 text-green-600 border-green-600 hover:bg-green-50"
                                          onClick={() => pagarComissao(comissao.id)}
                                        >
                                          <CheckCircle className="h-3 w-3" />
                                          Pagar
                                        </Button>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                                <TableRow className="bg-purple-100 font-bold">
                                  <TableCell colSpan={5} className="text-right">Total Gerente Administrativo:</TableCell>
                                  <TableCell className="text-center text-purple-700">
                                    {formatCurrency(totalGerAdmClaudio)}
                                  </TableCell>
                                  <TableCell colSpan={3}></TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </CardContent>
                          )}
                        </Card>
                    );
                  })()}
                </div>
              </>
            );
          })()}
        </TabsContent>

        {/* Tab: Comissões Pagas */}
        <TabsContent value="comissoes_pagas" className="space-y-4">
          {(() => {
            const comissoesPagas = comissoes.filter(c => c.status === "PAGO");
            
            // Agrupar por operador
            const operadoresPagosMap = {};
            comissoesPagas.forEach(comissao => {
              const operadorKey = comissao.operador || comissao.vendedor || "Sem Operador";
              if (!operadoresPagosMap[operadorKey]) {
                operadoresPagosMap[operadorKey] = {
                  nome: operadorKey,
                  perfil: comissao.perfil_operador || "ATENDENTE",
                  comissoes: []
                };
              }
              operadoresPagosMap[operadorKey].comissoes.push(comissao);
            });
            const operadoresPagosList = Object.values(operadoresPagosMap);
            
            // Calcular totais
            const totalRecebidoEmpresa = comissoesPagas.reduce((acc, c) => acc + (c.valor_recebido || c.valor_empresa || 0), 0);
            const totalPagoOperadores = comissoesPagas.reduce((acc, c) => {
              const base = c.valor_recebido || c.valor_empresa || 0;
              const isAtendente = (c.perfil_operador || "ATENDENTE").toUpperCase() === "ATENDENTE";
              const isCorretor = (c.perfil_operador || "").toUpperCase() === "CORRETOR";
              return acc + (isAtendente ? (base * (c.percentual_atendente || 5)) / 100 : isCorretor ? (base * (c.percentual_corretor || 30)) / 100 : 0);
            }, 0);
            const totalPagoGerAdm = comissoesPagas.reduce((acc, c) => {
              const base = c.valor_recebido || c.valor_empresa || 0;
              return acc + (base * (c.percentual_ger_adm || 10)) / 100;
            }, 0);
            const totalImpostos = comissoesPagas.reduce((acc, c) => {
              const base = c.valor_recebido || c.valor_empresa || 0;
              return acc + (base * (c.percentual_imposto || 15)) / 100;
            }, 0);
            const lucroLiquidoTotal = totalRecebidoEmpresa - totalPagoOperadores - totalPagoGerAdm - totalImpostos;
            
            return (
              <>
                {/* Header com Totais da Empresa */}
                <Card className="border-2 border-green-200">
                  <CardHeader className="bg-gradient-to-r from-green-50 to-emerald-50">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="w-14 h-14 rounded-full flex items-center justify-center bg-green-100">
                          <Building2 className="h-7 w-7 text-green-700" />
                        </div>
                        <div>
                          <CardTitle className="text-xl flex items-center gap-2">
                            Relatório da Empresa
                            <Badge className="bg-green-500 text-white">{comissoesPagas.length} contratos</Badge>
                          </CardTitle>
                          <CardDescription>Resumo de comissões recebidas e pagas</CardDescription>
                        </div>
                      </div>
                      <Button 
                        size="sm" 
                        className="gap-1 bg-green-600 hover:bg-green-700"
                        onClick={gerarPDFComissoesPagas}
                      >
                        <Download className="h-4 w-4" />
                        Baixar Relatório
                      </Button>
                    </div>
                  </CardHeader>
                  <CardContent className="pt-6">
                    <div className="grid grid-cols-5 gap-4">
                      <Card className="bg-green-50 border-green-200">
                        <CardContent className="pt-4 text-center">
                          <p className="text-xs text-gray-600 mb-1">Total Recebido (Banco)</p>
                          <p className="text-2xl font-bold text-green-700">{formatCurrency(totalRecebidoEmpresa)}</p>
                        </CardContent>
                      </Card>
                      <Card className="bg-orange-50 border-orange-200">
                        <CardContent className="pt-4 text-center">
                          <p className="text-xs text-gray-600 mb-1">Pago Operadores</p>
                          <p className="text-2xl font-bold text-orange-700">{formatCurrency(totalPagoOperadores)}</p>
                        </CardContent>
                      </Card>
                      <Card className="bg-purple-50 border-purple-200">
                        <CardContent className="pt-4 text-center">
                          <p className="text-xs text-gray-600 mb-1">Pago Ger. Adm</p>
                          <p className="text-2xl font-bold text-purple-700">{formatCurrency(totalPagoGerAdm)}</p>
                        </CardContent>
                      </Card>
                      <Card className="bg-red-50 border-red-200">
                        <CardContent className="pt-4 text-center">
                          <p className="text-xs text-gray-600 mb-1">Impostos</p>
                          <p className="text-2xl font-bold text-red-700">{formatCurrency(totalImpostos)}</p>
                        </CardContent>
                      </Card>
                      <Card className="bg-emerald-50 border-emerald-200">
                        <CardContent className="pt-4 text-center">
                          <p className="text-xs text-gray-600 mb-1">Lucro Líquido</p>
                          <p className="text-2xl font-bold text-emerald-700">{formatCurrency(lucroLiquidoTotal)}</p>
                        </CardContent>
                      </Card>
                    </div>
                    
                    {/* Card Empresa */}
                    <div className="mt-6">
                    <Card className="border-l-4 border-l-green-500">
                      <CardHeader 
                        className="bg-gradient-to-r from-green-50 to-white cursor-pointer select-none"
                        onClick={() => setExpandedOperadores(prev => ({...prev, ["emp-card"]: !prev["emp-card"]}))}
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="w-12 h-12 rounded-full flex items-center justify-center bg-green-100">
                              <Building2 className="h-6 w-6 text-green-700" />
                            </div>
                            <div>
                              <CardTitle className="text-lg flex items-center gap-2">
                                MATRIZ STILOCRED
                                <Badge variant="outline" className="text-xs bg-green-100 text-green-700">
                                  EMPRESA
                                </Badge>
                              </CardTitle>
                              <CardDescription className="text-xs">{comissoesPagas.length} contrato(s) com comissao recebida</CardDescription>
                            </div>
                          </div>
                          <div className="flex items-center gap-4">
                            <div className="grid grid-cols-4 gap-4 text-right">
                              <div>
                                <p className="text-[10px] text-gray-500">Recebido</p>
                                <p className="text-sm font-bold text-green-700">{formatCurrency(totalRecebidoEmpresa)}</p>
                              </div>
                              <div>
                                <p className="text-[10px] text-gray-500">Pago Equipe</p>
                                <p className="text-sm font-bold text-orange-600">{formatCurrency(totalPagoOperadores + totalPagoGerAdm)}</p>
                              </div>
                              <div>
                                <p className="text-[10px] text-gray-500">Impostos</p>
                                <p className="text-sm font-bold text-red-600">{formatCurrency(totalImpostos)}</p>
                              </div>
                              <div>
                                <p className="text-[10px] text-gray-500">Lucro Liquido</p>
                                <p className="text-sm font-bold text-emerald-700">{formatCurrency(lucroLiquidoTotal)}</p>
                              </div>
                            </div>
                            <Button size="sm" variant="outline" className="gap-1 border-green-600 text-green-600" onClick={(e) => { e.stopPropagation(); gerarPDFComissoesPagas(); }}>
                              <Download className="h-4 w-4" /> Baixar
                            </Button>
                            <ChevronDown className={`h-5 w-5 text-gray-400 transition-transform ${expandedOperadores["emp-card"] ? 'rotate-180' : ''}`} />
                          </div>
                        </div>
                      </CardHeader>
                      {expandedOperadores["emp-card"] && (
                      <CardContent className="pt-3 space-y-2">
                      {(() => {
                        const pagasPorData = {};
                        comissoesPagas.forEach(c => {
                          const dt = c.data_pagamento ? c.data_pagamento.substring(0, 10) : "Sem Data";
                          if (!pagasPorData[dt]) pagasPorData[dt] = [];
                          pagasPorData[dt].push(c);
                        });
                        const datasOrd = Object.keys(pagasPorData).sort().reverse();
                        
                        return datasOrd.length === 0 ? (
                          <div className="h-24 flex items-center justify-center text-muted-foreground">Nenhuma comissao paga no periodo</div>
                        ) : datasOrd.map((data) => {
                          const items = pagasPorData[data];
                          const dataKey = `emp-data-${data}`;
                          const dataFmt = data !== "Sem Data" ? data.split("-").reverse().join("/") : "Sem Data";
                          let totalDiaRecebido = 0, totalDiaOp = 0, totalDiaGer = 0, totalDiaImp = 0, totalDiaLucro = 0;
                          items.forEach(c => {
                            const base = c.valor_recebido || c.valor_empresa || 0;
                            const isAten = (c.perfil_operador || "ATENDENTE").toUpperCase() === "ATENDENTE";
                            const isCorr = (c.perfil_operador || "").toUpperCase() === "CORRETOR";
                            const vOp = isAten ? (base * (c.percentual_atendente || 5)) / 100 : isCorr ? (base * (c.percentual_corretor || 30)) / 100 : 0;
                            const vGer = (base * (c.percentual_ger_adm || 10)) / 100;
                            const vImp = (base * (c.percentual_imposto || 15)) / 100;
                            totalDiaRecebido += base;
                            totalDiaOp += vOp;
                            totalDiaGer += vGer;
                            totalDiaImp += vImp;
                            totalDiaLucro += base - vOp - vGer - vImp;
                          });
                          
                          return (
                            <div key={dataKey} className="border rounded-lg overflow-hidden">
                              <div className="flex items-center justify-between px-4 py-2 bg-green-50 cursor-pointer hover:bg-green-100" onClick={() => setExpandedOperadores(prev => ({...prev, [dataKey]: !prev[dataKey]}))}>
                                <div className="flex items-center gap-2">
                                  <ChevronDown className={`h-4 w-4 text-gray-500 transition-transform ${expandedOperadores[dataKey] ? 'rotate-180' : ''}`} />
                                  <span className="font-bold text-sm">{dataFmt}</span>
                                  <Badge variant="outline" className="text-xs bg-green-100">{items.length} contrato(s)</Badge>
                                </div>
                                <div className="flex items-center gap-4 text-xs">
                                  <span>Recebido: <strong className="text-green-700">{formatCurrency(totalDiaRecebido)}</strong></span>
                                  <span>Operador: <strong className="text-orange-700">{formatCurrency(totalDiaOp)}</strong></span>
                                  <span>Ger.Adm: <strong className="text-purple-700">{formatCurrency(totalDiaGer)}</strong></span>
                                  <span>Lucro: <strong className="text-emerald-700">{formatCurrency(totalDiaLucro)}</strong></span>
                                </div>
                              </div>
                              {expandedOperadores[dataKey] && (
                              <Table>
                                <TableHeader><TableRow className="bg-green-50 text-xs">
                                  <TableHead>Operador</TableHead><TableHead>Cliente</TableHead><TableHead>Contrato</TableHead><TableHead>Banco/Tipo</TableHead><TableHead>Vlr Contrato</TableHead><TableHead>Recebido</TableHead><TableHead>Operador</TableHead><TableHead>Ger.Adm</TableHead><TableHead>Imposto</TableHead><TableHead>Lucro</TableHead>
                                </TableRow></TableHeader>
                                <TableBody>
                                  {items.map((comissao) => {
                                    const base = comissao.valor_recebido || comissao.valor_empresa || 0;
                                    const isAten2 = (comissao.perfil_operador || "ATENDENTE").toUpperCase() === "ATENDENTE";
                                    const isCorr2 = (comissao.perfil_operador || "").toUpperCase() === "CORRETOR";
                                    const valorOp = isAten2 ? (base * (comissao.percentual_atendente || 5)) / 100 : isCorr2 ? (base * (comissao.percentual_corretor || 30)) / 100 : 0;
                                    const valorGer = (base * (comissao.percentual_ger_adm || 10)) / 100;
                                    const valorImp = (base * (comissao.percentual_imposto || 15)) / 100;
                                    const lucroItem = base - valorOp - valorGer - valorImp;
                                    const opNome = (comissao.operador || comissao.vendedor || "-").split(" ").slice(0, 2).join(" ");
                                    return (
                                      <TableRow key={`e-${comissao.id}`} className="text-sm">
                                        <TableCell><p className="text-xs font-medium">{opNome}</p></TableCell>
                                        <TableCell className="text-sm">{comissao.cliente_nome || "-"}</TableCell>
                                        <TableCell className="font-mono text-sm">{comissao.numero_contrato || "-"}</TableCell>
                                        <TableCell className="text-sm">{comissao.banco_nome || "-"}</TableCell>
                                        <TableCell>{formatCurrency(comissao.valor_contrato)}</TableCell>
                                        <TableCell className="font-semibold text-green-700">{formatCurrency(base)}</TableCell>
                                        <TableCell className="text-orange-700">{formatCurrency(valorOp)}</TableCell>
                                        <TableCell className="text-purple-700">{formatCurrency(valorGer)}</TableCell>
                                        <TableCell className="text-red-700">{formatCurrency(valorImp)}</TableCell>
                                        <TableCell className="font-semibold text-emerald-700">{formatCurrency(lucroItem)}</TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                              )}
                            </div>
                          );
                        });
                      })()}
                      </CardContent>
                      )}
                    </Card>
                    </div>
                    </CardContent>
                </Card>
                
                {/* === SEÇÃO: RELATÓRIOS POR OPERADOR (CORRETOR/ATENDENTE) === */}
                <div className="space-y-4 mt-6">
                  <h3 className="text-lg font-semibold text-gray-700 flex items-center gap-2">
                    <Users className="h-5 w-5" />
                    Relatórios por Operador (Corretor / Atendente)
                  </h3>
                  
                  {operadoresPagosList.length === 0 ? (
                    <Card>
                      <CardContent className="h-24 flex items-center justify-center text-muted-foreground">
                        Nenhuma comissao paga a operadores
                      </CardContent>
                    </Card>
                  ) : (
                    operadoresPagosList.map((operador) => {
                      const partesNome = operador.nome.trim().split(" ");
                      const codigoOperador = partesNome[0] || "";
                      const nomeOperador = partesNome.slice(1).join(" ") || operador.nome;
                      const isCorretor = operador.perfil.toUpperCase() === "CORRETOR";
                      const isAtendente = operador.perfil.toUpperCase() === "ATENDENTE";
                      let totalPagoOperador = 0;
                      operador.comissoes.forEach(c => {
                        const base = c.valor_recebido || c.valor_empresa || 0;
                        if (isAtendente) totalPagoOperador += (base * (c.percentual_atendente || 5)) / 100;
                        else if (isCorretor) totalPagoOperador += (base * (c.percentual_corretor || 30)) / 100;
                      });
                      const comPorDataOp = {};
                      operador.comissoes.forEach(c => {
                        const dt = c.data_pagamento ? c.data_pagamento.substring(0, 10) : "Sem Data";
                        if (!comPorDataOp[dt]) comPorDataOp[dt] = [];
                        comPorDataOp[dt].push(c);
                      });
                      const datasOrdOp = Object.keys(comPorDataOp).sort().reverse();
                      return (
                        <Card key={`pago-op-${operador.nome}`} className={`border-l-4 ${isCorretor ? 'border-l-yellow-500' : 'border-l-orange-500'}`}>
                          <CardHeader 
                            className={`bg-gradient-to-r ${isCorretor ? 'from-yellow-50' : 'from-orange-50'} to-white cursor-pointer select-none`}
                            onClick={() => setExpandedOperadores(prev => ({...prev, [`pago-op-${operador.nome}`]: !prev[`pago-op-${operador.nome}`]}))}
                          >
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-3">
                                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${isCorretor ? 'bg-yellow-100' : 'bg-orange-100'}`}>
                                  <Users className={`h-5 w-5 ${isCorretor ? 'text-yellow-700' : 'text-orange-700'}`} />
                                </div>
                                <div>
                                  <CardTitle className="text-base flex items-center gap-2">
                                    {nomeOperador}
                                    <Badge variant="outline" className={`text-xs ${isCorretor ? 'bg-yellow-100 text-yellow-700' : 'bg-orange-100 text-orange-700'}`}>{operador.perfil}</Badge>
                                  </CardTitle>
                                  <CardDescription className="text-xs">Codigo: {codigoOperador} - {operador.comissoes.length} contrato(s) pago(s)</CardDescription>
                                </div>
                              </div>
                              <div className="flex items-center gap-3">
                                <div className="text-right">
                                  <p className="text-xs text-gray-500">Total Pago</p>
                                  <p className={`text-lg font-bold ${isCorretor ? 'text-yellow-700' : 'text-orange-700'}`}>{formatCurrency(totalPagoOperador)}</p>
                                </div>
                                <Button size="sm" variant="outline" className={`gap-1 ${isCorretor ? 'border-yellow-600 text-yellow-600' : 'border-orange-600 text-orange-600'}`} onClick={(e) => { e.stopPropagation(); gerarPDFOperador(operador, operador.comissoes); }}>
                                  <Download className="h-4 w-4" /> Baixar
                                </Button>
                                <ChevronDown className={`h-5 w-5 text-gray-400 transition-transform ${expandedOperadores[`pago-op-${operador.nome}`] ? 'rotate-180' : ''}`} />
                              </div>
                            </div>
                          </CardHeader>
                          {expandedOperadores[`pago-op-${operador.nome}`] && (
                          <CardContent className="pt-3 space-y-2">
                            {datasOrdOp.map((dt) => {
                              const items = comPorDataOp[dt];
                              const dKey = `pago-op-${operador.nome}-${dt}`;
                              const dtFmt = dt !== "Sem Data" ? dt.split("-").reverse().join("/") : "Sem Data";
                              let totalDiaOp = 0;
                              items.forEach(c => {
                                const base = c.valor_recebido || c.valor_empresa || 0;
                                if (isAtendente) totalDiaOp += (base * (c.percentual_atendente || 5)) / 100;
                                else if (isCorretor) totalDiaOp += (base * (c.percentual_corretor || 30)) / 100;
                              });
                              return (
                                <div key={dKey} className="border rounded-lg overflow-hidden">
                                  <div className="flex items-center justify-between px-4 py-2 bg-gray-50 cursor-pointer hover:bg-gray-100" onClick={() => setExpandedOperadores(prev => ({...prev, [dKey]: !prev[dKey]}))}>
                                    <div className="flex items-center gap-2">
                                      <ChevronDown className={`h-4 w-4 text-gray-400 transition-transform ${expandedOperadores[dKey] ? 'rotate-180' : ''}`} />
                                      <span className="font-semibold text-sm">{dtFmt}</span>
                                      <Badge variant="outline" className="text-xs">{items.length} contrato(s)</Badge>
                                    </div>
                                    <span className={`font-bold text-sm ${isCorretor ? 'text-yellow-700' : 'text-orange-700'}`}>{formatCurrency(totalDiaOp)}</span>
                                  </div>
                                  {expandedOperadores[dKey] && (
                                  <Table>
                                    <TableHeader><TableRow className="bg-gray-50 text-xs">
                                      <TableHead>Cliente</TableHead><TableHead>Contrato</TableHead><TableHead>Banco</TableHead><TableHead>Valor Contrato</TableHead><TableHead>Comissao</TableHead>
                                    </TableRow></TableHeader>
                                    <TableBody>
                                      {items.map((c) => {
                                        const base = c.valor_recebido || c.valor_empresa || 0;
                                        const pct = isAtendente ? (c.percentual_atendente || 5) : (c.percentual_corretor || 30);
                                        return (
                                          <TableRow key={c.id} className="text-sm">
                                            <TableCell>{c.cliente_nome || "-"}</TableCell>
                                            <TableCell className="font-mono">{c.numero_contrato || "-"}</TableCell>
                                            <TableCell>{c.banco_nome || "-"}</TableCell>
                                            <TableCell>{formatCurrency(c.valor_contrato)}</TableCell>
                                            <TableCell className={`font-bold ${isCorretor ? 'text-yellow-700' : 'text-orange-700'}`}>{formatCurrency((base * pct) / 100)}</TableCell>
                                          </TableRow>
                                        );
                                      })}
                                    </TableBody>
                                  </Table>
                                  )}
                                </div>
                              );
                            })}
                          </CardContent>
                          )}
                        </Card>
                      );
                    })
                  )}
                {/* === SEÇÃO: RELATÓRIO GERENTE ADMINISTRATIVO === */}
                </div>
                <div className="space-y-4 mt-6">
                  <h3 className="text-lg font-semibold text-purple-700 flex items-center gap-2">
                    <CircleDollarSign className="h-5 w-5" />
                    Relatório Gerente Administrativo
                  </h3>
                  
                  {comissoesPagas.length === 0 ? (
                    <Card>
                      <CardContent className="h-24 flex items-center justify-center text-muted-foreground">
                        Nenhuma comissao paga ao Ger. Adm
                      </CardContent>
                    </Card>
                  ) : (() => {
                    const gerPorData = {};
                    comissoesPagas.forEach(c => {
                      const dt = c.data_pagamento ? c.data_pagamento.substring(0, 10) : "Sem Data";
                      if (!gerPorData[dt]) gerPorData[dt] = [];
                      gerPorData[dt].push(c);
                    });
                    const datasGer = Object.keys(gerPorData).sort().reverse();
                    return (
                    <Card className="border-l-4 border-l-purple-500">
                      <CardHeader className="bg-gradient-to-r from-purple-50 to-white cursor-pointer select-none" onClick={() => setExpandedOperadores(prev => ({...prev, ["geradm-pagas"]: !prev["geradm-pagas"]}))}>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full flex items-center justify-center bg-purple-100">
                              <CircleDollarSign className="h-5 w-5 text-purple-700" />
                            </div>
                            <div>
                              <CardTitle className="text-base flex items-center gap-2">
                                CLAUDIO DOMINGOS DE FIGUEIREDO JUNIOR
                                <Badge variant="outline" className="text-xs bg-purple-100 text-purple-700">G. ADMIN</Badge>
                              </CardTitle>
                              <CardDescription className="text-xs">Codigo: PA0001 - {comissoesPagas.length} contrato(s) com comissao paga</CardDescription>
                            </div>
                          </div>
                          <div className="flex items-center gap-3">
                            <div className="text-right">
                              <p className="text-xs text-gray-500">Total Pago</p>
                              <p className="text-lg font-bold text-purple-700">{formatCurrency(totalPagoGerAdm)}</p>
                            </div>
                            <Button size="sm" variant="outline" className="gap-1 border-purple-600 text-purple-600" onClick={(e) => { e.stopPropagation(); gerarPDFGerAdm(); }}>
                              <Download className="h-4 w-4" /> Baixar
                            </Button>
                            <ChevronDown className={`h-5 w-5 text-gray-400 transition-transform ${expandedOperadores["geradm-pagas"] ? 'rotate-180' : ''}`} />
                          </div>
                        </div>
                      </CardHeader>
                      {expandedOperadores["geradm-pagas"] && (
                      <CardContent className="pt-3 space-y-2">
                        {datasGer.map((dt) => {
                          const items = gerPorData[dt];
                          const dKey = `geradm-pagas-${dt}`;
                          const dtFmt = dt !== "Sem Data" ? dt.split("-").reverse().join("/") : "Sem Data";
                          let totalDiaGer = 0;
                          items.forEach(c => { const base = c.valor_recebido || c.valor_empresa || 0; totalDiaGer += (base * (c.percentual_ger_adm || 10)) / 100; });
                          return (
                            <div key={dKey} className="border rounded-lg overflow-hidden">
                              <div className="flex items-center justify-between px-4 py-2 bg-purple-50 cursor-pointer hover:bg-purple-100" onClick={() => setExpandedOperadores(prev => ({...prev, [dKey]: !prev[dKey]}))}>
                                <div className="flex items-center gap-2">
                                  <ChevronDown className={`h-4 w-4 text-gray-400 transition-transform ${expandedOperadores[dKey] ? 'rotate-180' : ''}`} />
                                  <span className="font-semibold text-sm">{dtFmt}</span>
                                  <Badge variant="outline" className="text-xs bg-purple-100">{items.length} contrato(s)</Badge>
                                </div>
                                <span className="font-bold text-sm text-purple-700">{formatCurrency(totalDiaGer)}</span>
                              </div>
                              {expandedOperadores[dKey] && (
                              <Table>
                                <TableHeader><TableRow className="bg-purple-50 text-xs">
                                  <TableHead>Operador</TableHead><TableHead>Cliente</TableHead><TableHead>Contrato</TableHead><TableHead>Banco</TableHead><TableHead>Valor Contrato</TableHead><TableHead>Comissao Ger. Adm</TableHead>
                                </TableRow></TableHeader>
                                <TableBody>
                                  {items.map((c) => {
                                    const base = c.valor_recebido || c.valor_empresa || 0;
                                    const vGer = (base * (c.percentual_ger_adm || 10)) / 100;
                                    const opN = (c.operador || c.vendedor || "-").split(" ").slice(0, 2).join(" ");
                                    return (
                                      <TableRow key={`gp-${c.id}`} className="text-sm">
                                        <TableCell><p className="text-xs font-medium">{opN}</p><Badge variant="outline" className="text-[10px]">{c.perfil_operador || "ATENDENTE"}</Badge></TableCell>
                                        <TableCell>{c.cliente_nome || "-"}</TableCell>
                                        <TableCell className="font-mono">{c.numero_contrato || "-"}</TableCell>
                                        <TableCell>{c.banco_nome || "-"}</TableCell>
                                        <TableCell>{formatCurrency(c.valor_contrato)}</TableCell>
                                        <TableCell className="font-bold text-purple-700">{formatCurrency(vGer)}</TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                              )}
                            </div>
                          );
                        })}
                      </CardContent>
                      )}
                    </Card>
                    );
                  })()}
                </div>
              </>
            );
          })()}
        </TabsContent>

        {/* Tab: Transações */}
        <TabsContent value="transacoes" className="space-y-4">
          <Card>
            <CardHeader className="flex flex-row items-center justify-between">
              <div>
                <CardTitle>Transações Financeiras</CardTitle>
                <CardDescription>Registro de todas as movimentações</CardDescription>
              </div>
              <div className="flex items-center gap-2">
                <Select defaultValue="todos">
                  <SelectTrigger className="w-[150px]">
                    <SelectValue placeholder="Filtrar tipo" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="todos">Todos</SelectItem>
                    <SelectItem value="RECEITA">Receitas</SelectItem>
                    <SelectItem value="DESPESA">Despesas</SelectItem>
                  </SelectContent>
                </Select>
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <Input
                    placeholder="Buscar transação..."
                    className="pl-9 w-[200px]"
                  />
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Tipo</TableHead>
                    <TableHead>Categoria</TableHead>
                    <TableHead>Descrição</TableHead>
                    <TableHead>Valor</TableHead>
                    <TableHead>Data</TableHead>
                    <TableHead>Status</TableHead>
                    <TableHead className="text-right">Ações</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {transacoes.map((transacao) => (
                    <TableRow key={transacao.id}>
                      <TableCell>
                        <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
                          transacao.tipo === "RECEITA" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
                        }`}>
                          {transacao.tipo === "RECEITA" ? (
                            <ArrowUpRight className="h-3 w-3" />
                          ) : (
                            <ArrowDownLeft className="h-3 w-3" />
                          )}
                          {transacao.tipo}
                        </div>
                      </TableCell>
                      <TableCell>{transacao.categoria}</TableCell>
                      <TableCell className="max-w-[200px] truncate">{transacao.descricao}</TableCell>
                      <TableCell className={`font-semibold ${transacao.tipo === "RECEITA" ? "text-green-600" : "text-red-600"}`}>
                        {transacao.tipo === "RECEITA" ? "+" : "-"}{formatCurrency(transacao.valor)}
                      </TableCell>
                      <TableCell>{formatDate(transacao.data)}</TableCell>
                      <TableCell>{getStatusBadge(transacao.status)}</TableCell>
                      <TableCell className="text-right">
                        <div className="flex justify-end gap-1">
                          <Button size="sm" variant="ghost" className="h-8 w-8 p-0">
                            <Pencil className="h-4 w-4" />
                          </Button>
                          <Button size="sm" variant="ghost" className="h-8 w-8 p-0 text-red-500 hover:text-red-700">
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Tab: Fluxo de Caixa */}
        <TabsContent value="fluxo" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>Fluxo de Caixa</CardTitle>
              <CardDescription>Projeção de entradas e saídas</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {/* Resumo do Fluxo */}
                <div className="grid gap-4 md:grid-cols-3">
                  <div className="p-4 rounded-lg bg-green-50 border border-green-200">
                    <div className="flex items-center gap-2 text-green-700 mb-2">
                      <ArrowUpRight className="h-5 w-5" />
                      <span className="font-medium">Entradas Previstas</span>
                    </div>
                    <p className="text-2xl font-bold text-green-700">{formatCurrency(0)}</p>
                    <p className="text-sm text-green-600 mt-1">Próximos 30 dias</p>
                  </div>
                  <div className="p-4 rounded-lg bg-red-50 border border-red-200">
                    <div className="flex items-center gap-2 text-red-700 mb-2">
                      <ArrowDownLeft className="h-5 w-5" />
                      <span className="font-medium">Saídas Previstas</span>
                    </div>
                    <p className="text-2xl font-bold text-red-700">{formatCurrency(0)}</p>
                    <p className="text-sm text-red-600 mt-1">Próximos 30 dias</p>
                  </div>
                  <div className="p-4 rounded-lg bg-blue-50 border border-blue-200">
                    <div className="flex items-center gap-2 text-blue-700 mb-2">
                      <Wallet className="h-5 w-5" />
                      <span className="font-medium">Saldo Projetado</span>
                    </div>
                    <p className="text-2xl font-bold text-blue-700">{formatCurrency(0)}</p>
                    <p className="text-sm text-blue-600 mt-1">Ao final do período</p>
                  </div>
                </div>

                <Separator />

                {/* Tabela de Fluxo */}
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Data</TableHead>
                      <TableHead>Descrição</TableHead>
                      <TableHead className="text-right text-green-600">Entradas</TableHead>
                      <TableHead className="text-right text-red-600">Saídas</TableHead>
                      <TableHead className="text-right">Saldo</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={5} className="h-24 text-center text-muted-foreground">
                        Nenhuma movimentação registrada no período
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Tab: Débitos */}
        <TabsContent value="debitos" className="space-y-4">
          {/* Cards de Resumo de Débitos */}
          <div className="grid gap-4 md:grid-cols-3">
            <Card className="border-red-200 bg-red-50">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium text-red-800">Total Débitos Pendentes</CardTitle>
                <MinusCircle className="h-4 w-4 text-red-600" />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold text-red-700">{formatCurrency(debitosResumo.total_pendente)}</div>
                <p className="text-xs text-red-600 mt-1">
                  {debitos.filter(d => d.status === "PENDENTE").length} débito(s) a descontar
                </p>
              </CardContent>
            </Card>

            <Card className="border-green-200 bg-green-50">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium text-green-800">Total Já Processado</CardTitle>
                <CheckCircle className="h-4 w-4 text-green-600" />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold text-green-700">{formatCurrency(debitosResumo.total_processado)}</div>
                <p className="text-xs text-green-600 mt-1">
                  {debitos.filter(d => d.status === "PROCESSADO").length} débito(s) quitado(s)
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">Beneficiários com Débito</CardTitle>
                <Users className="h-4 w-4 text-muted-foreground" />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">
                  {[...new Set(debitos.filter(d => d.status === "PENDENTE").map(d => d.beneficiario))].length}
                </div>
                <p className="text-xs text-muted-foreground mt-1">
                  Pessoas com saldo devedor
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Tabela de Débitos */}
          <Card>
            <CardHeader>
              <div className="flex items-center justify-between">
                <div>
                  <CardTitle className="flex items-center gap-2">
                    <RotateCcw className="h-5 w-5 text-red-600" />
                    Débitos de Estorno
                  </CardTitle>
                  <CardDescription>
                    Valores a serem descontados nas próximas comissões dos beneficiários
                  </CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              {debitos.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-12 text-muted-foreground">
                  <CheckCircle className="h-12 w-12 mb-4 text-green-500" />
                  <p className="text-lg font-medium">Nenhum débito pendente</p>
                  <p className="text-sm">Todos os estornos foram quitados</p>
                </div>
              ) : (
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Beneficiário</TableHead>
                      <TableHead>Tipo</TableHead>
                      <TableHead>Contrato</TableHead>
                      <TableHead>Cliente</TableHead>
                      <TableHead className="text-right">Valor Original</TableHead>
                      <TableHead className="text-right">Saldo Devedor</TableHead>
                      <TableHead>Data Estorno</TableHead>
                      <TableHead>Status</TableHead>
                      <TableHead>Motivo</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {debitos.map((debito) => (
                      <TableRow key={debito.id} className={debito.status === "PENDENTE" ? "bg-red-50" : ""}>
                        <TableCell className="font-medium">{debito.beneficiario}</TableCell>
                        <TableCell>
                          <Badge variant="outline" className="text-xs">
                            {debito.tipo_beneficiario === "OPERADOR" ? "Operador" : "Ger. Adm"}
                          </Badge>
                        </TableCell>
                        <TableCell className="font-mono text-xs">{debito.contrato_codigo || debito.contrato_id?.slice(0, 8)}</TableCell>
                        <TableCell>{debito.cliente_nome}</TableCell>
                        <TableCell className="text-right font-medium">{formatCurrency(debito.valor_original)}</TableCell>
                        <TableCell className="text-right font-bold text-red-600">
                          {formatCurrency(debito.saldo_debito)}
                        </TableCell>
                        <TableCell>{formatDate(debito.data_estorno)}</TableCell>
                        <TableCell>
                          <Badge 
                            variant={debito.status === "PENDENTE" ? "destructive" : "default"}
                            className={debito.status === "PROCESSADO" ? "bg-green-500" : ""}
                          >
                            {debito.status === "PENDENTE" ? "Pendente" : "Quitado"}
                          </Badge>
                        </TableCell>
                        <TableCell className="max-w-[200px] truncate text-xs text-muted-foreground" title={debito.motivo}>
                          {debito.motivo}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}

              {/* Resumo por Beneficiário */}
              {debitos.filter(d => d.status === "PENDENTE").length > 0 && (
                <div className="mt-6 pt-6 border-t">
                  <h4 className="font-semibold mb-4 flex items-center gap-2">
                    <Users className="h-4 w-4" />
                    Resumo por Beneficiário
                  </h4>
                  <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
                    {[...new Set(debitos.filter(d => d.status === "PENDENTE").map(d => d.beneficiario))].map(beneficiario => {
                      const debitosBeneficiario = debitos.filter(d => d.beneficiario === beneficiario && d.status === "PENDENTE");
                      const totalDebito = debitosBeneficiario.reduce((acc, d) => acc + (d.saldo_debito || 0), 0);
                      return (
                        <Card key={beneficiario} className="bg-slate-50">
                          <CardContent className="pt-4">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="font-medium">{beneficiario}</p>
                                <p className="text-xs text-muted-foreground">{debitosBeneficiario.length} débito(s)</p>
                              </div>
                              <div className="text-right">
                                <p className="font-bold text-red-600">{formatCurrency(totalDebito)}</p>
                                <p className="text-xs text-muted-foreground">a descontar</p>
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                      );
                    })}
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
      
      {/* Modal Importar Relatório do Banco */}
      <Dialog open={showImportarRelatorioBanco} onOpenChange={setShowImportarRelatorioBanco}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileSpreadsheet className="h-5 w-5 text-green-600" />
              Importar Relatório do Banco
            </DialogTitle>
            <DialogDescription>
              Importe o relatório de comissões do banco para conciliar automaticamente os pagamentos recebidos
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            {/* Seleção do Banco */}
            <div className="space-y-2">
              <Label htmlFor="banco-relatorio" className="text-sm font-medium">
                Banco{importRelatorioFormato === "padrao" ? "*" : " (opcional - detectado do arquivo)"}
              </Label>
              <Select value={importRelatorioBanco} onValueChange={setImportRelatorioBanco}>
                <SelectTrigger id="banco-relatorio">
                  <SelectValue placeholder="Selecione o banco" />
                </SelectTrigger>
                <SelectContent>
                  {[...new Set(comissoes.map(c => c.banco_nome || c.banco_codigo).filter(Boolean))].map(banco => (
                    <SelectItem key={banco} value={banco}>{banco}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            {/* Seleção do Formato */}
            <div className="space-y-2">
              <Label className="text-sm font-medium">Formato do Relatório*</Label>
              <div className="grid grid-cols-5 gap-3">
                <button
                  type="button"
                  onClick={() => setImportRelatorioFormato("padrao")}
                  className={`border-2 rounded-lg p-3 text-center transition-all ${importRelatorioFormato === "padrao" ? "border-green-500 bg-green-50 ring-2 ring-green-200" : "border-gray-200 hover:border-green-300"}`}
                >
                  <FileSpreadsheet className="h-5 w-5 mx-auto mb-1 text-green-600" />
                  <p className="font-semibold text-sm text-green-800">Padrão</p>
                  <p className="text-[10px] text-gray-500 mt-1">Layout padrão banco</p>
                </button>
                <button
                  type="button"
                  onClick={() => setImportRelatorioFormato("port")}
                  className={`border-2 rounded-lg p-3 text-center transition-all ${importRelatorioFormato === "port" ? "border-orange-500 bg-orange-50 ring-2 ring-orange-200" : "border-gray-200 hover:border-orange-300"}`}
                >
                  <FileSpreadsheet className="h-5 w-5 mx-auto mb-1 text-orange-600" />
                  <p className="font-semibold text-sm text-orange-800">PORT</p>
                  <p className="text-[10px] text-gray-500 mt-1">Relatório PORT Promotora</p>
                </button>
                <button
                  type="button"
                  onClick={() => setImportRelatorioFormato("lev")}
                  className={`border-2 rounded-lg p-3 text-center transition-all ${importRelatorioFormato === "lev" ? "border-blue-500 bg-blue-50 ring-2 ring-blue-200" : "border-gray-200 hover:border-blue-300"}`}
                >
                  <FileSpreadsheet className="h-5 w-5 mx-auto mb-1 text-blue-600" />
                  <p className="font-semibold text-sm text-blue-800">LEV</p>
                  <p className="text-[10px] text-gray-500 mt-1">Relatório Levantamento</p>
                </button>
                <button
                  type="button"
                  onClick={() => setImportRelatorioFormato("fintech")}
                  className={`border-2 rounded-lg p-3 text-center transition-all ${importRelatorioFormato === "fintech" ? "border-emerald-500 bg-emerald-50 ring-2 ring-emerald-200" : "border-gray-200 hover:border-emerald-300"}`}
                >
                  <FileSpreadsheet className="h-5 w-5 mx-auto mb-1 text-emerald-600" />
                  <p className="font-semibold text-sm text-emerald-800">FINTECH</p>
                  <p className="text-[10px] text-gray-500 mt-1">Relatório FINTECH</p>
                </button>
                <button
                  type="button"
                  onClick={() => setImportRelatorioFormato("pontoamigo")}
                  data-testid="rel-formato-pontoamigo"
                  className={`border-2 rounded-lg p-3 text-center transition-all ${importRelatorioFormato === "pontoamigo" ? "border-pink-500 bg-pink-50 ring-2 ring-pink-200" : "border-gray-200 hover:border-pink-300"}`}
                >
                  <FileSpreadsheet className="h-5 w-5 mx-auto mb-1 text-pink-600" />
                  <p className="font-semibold text-sm text-pink-800">Ponto Amigo</p>
                  <p className="text-[10px] text-gray-500 mt-1">Consulta Comissao</p>
                </button>
              </div>
            </div>
            
            {/* Upload do Arquivo */}
            <div className="space-y-2">
              <Label htmlFor="arquivo-relatorio" className="text-sm font-medium">Arquivo do Relatório*</Label>
              <div className="border-2 border-dashed border-gray-200 rounded-lg p-4 hover:border-green-400 transition-colors">
                <input id="arquivo-relatorio" type="file" accept=".xlsx,.xls,.csv" onChange={handleImportRelatorioChange} className="hidden" />
                <label htmlFor="arquivo-relatorio" className="flex flex-col items-center cursor-pointer">
                  <Upload className="h-8 w-8 text-gray-400 mb-2" />
                  <span className="text-sm text-gray-600">Clique para selecionar ou arraste o arquivo</span>
                  <span className="text-xs text-gray-400 mt-1">Formatos aceitos: Excel (.xlsx, .xls) ou CSV (.csv)</span>
                </label>
              </div>
              {importRelatorioPreview && (
                <div className="flex items-center gap-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                  <FileSpreadsheet className="h-8 w-8 text-green-600" />
                  <div className="flex-1">
                    <p className="font-medium text-sm text-green-800">{importRelatorioPreview.nome}</p>
                    <p className="text-xs text-green-600">{importRelatorioPreview.tamanho} • {importRelatorioPreview.tipo}</p>
                  </div>
                  <Button variant="ghost" size="sm" className="text-red-500 hover:text-red-700" onClick={() => { setImportRelatorioFile(null); setImportRelatorioPreview(null); }}>
                    <XCircle className="h-4 w-4" />
                  </Button>
                </div>
              )}
            </div>
            
            {/* Instruções dinâmicas por formato */}
            <div className={`border rounded-lg p-3 ${importRelatorioFormato === "padrao" ? "bg-green-50 border-green-200" : importRelatorioFormato === "port" ? "bg-orange-50 border-orange-200" : importRelatorioFormato === "fintech" ? "bg-emerald-50 border-emerald-200" : importRelatorioFormato === "pontoamigo" ? "bg-pink-50 border-pink-200" : "bg-blue-50 border-blue-200"}`}>
              <h4 className={`font-medium text-sm mb-2 ${importRelatorioFormato === "padrao" ? "text-green-800" : importRelatorioFormato === "port" ? "text-orange-800" : importRelatorioFormato === "fintech" ? "text-emerald-800" : importRelatorioFormato === "pontoamigo" ? "text-pink-800" : "text-blue-800"}`}>
                Colunas esperadas - {importRelatorioFormato === "padrao" ? "Padrão" : importRelatorioFormato === "port" ? "PORT" : importRelatorioFormato === "fintech" ? "FINTECH" : importRelatorioFormato === "pontoamigo" ? "Ponto Amigo" : "LEV"}:
              </h4>
              {importRelatorioFormato === "padrao" && (
                <ul className="text-xs text-green-700 space-y-1">
                  <li>• <strong>Numero do Contrato</strong>: Identificador único</li>
                  <li>• <strong>Valor Comissao</strong>: Valor recebido</li>
                  <li>• <strong>Data Pagamento</strong>: Data do recebimento (opcional)</li>
                  <li>• <strong>CPF Cliente</strong>: CPF do cliente (opcional)</li>
                </ul>
              )}
              {importRelatorioFormato === "port" && (
                <ul className="text-xs text-orange-700 space-y-1">
                  <li>• <strong>Nº Contrato</strong>: Número do contrato</li>
                  <li>• <strong>Vlr. Comissão</strong>: Valor da comissão recebida</li>
                  <li>• <strong>Data Quitação</strong>: Data do pagamento</li>
                  <li>• <strong>CPF</strong>: CPF do cliente</li>
                  <li>• <strong>Banco</strong>: Banco do contrato</li>
                  <li>• <strong>Base Cálculo</strong>: Valor do contrato</li>
                  <li>• <strong>Cliente</strong>: Nome do cliente</li>
                  <li>• <strong>Tabela</strong>: Tabela de comissão</li>
                  <li>• <strong>Produto</strong>: Tipo de produto</li>
                  <li>• <strong>Convenio</strong>: Instituição/Convênio</li>
                  <li>• <strong>Comissão %</strong>: Percentual de comissão</li>
                </ul>
              )}
              {importRelatorioFormato === "lev" && (
                <ul className="text-xs text-blue-700 space-y-1">
                  <li>• <strong>CONTRATO</strong> / <strong>PROPOSTA</strong>: Número do contrato</li>
                  <li>• <strong>VAL. COMISSAO</strong>: Valor da comissão</li>
                  <li>• <strong>BAIXA CMS</strong>: Data do pagamento</li>
                  <li>• <strong>CPF</strong> / <strong>CLIENTE</strong>: Identificação</li>
                  <li>• <strong>BANCO</strong> / <strong>PRODUTO</strong> / <strong>TIPO</strong>: Mapeamento automático</li>
                </ul>
              )}
              {importRelatorioFormato === "pontoamigo" && (
                <ul className="text-xs text-pink-700 space-y-1">
                  <li>• Mesmo layout do extrato <strong>Consulta Comissão</strong> (header na linha 3)</li>
                  <li>• <strong>CONTRATO</strong> / <strong>PROPOSTA</strong>: Número do contrato</li>
                  <li>• <strong>VAL. COMISSAO</strong>: Valor da comissão</li>
                  <li>• <strong>BAIXA CMS</strong>: Data do pagamento</li>
                  <li>• <strong>BANCO</strong>: Mapeado automaticamente para o cadastro de bancos</li>
                  <li>• Correspondente: <strong>PONTO AMIGO PROMOTORA</strong></li>
                </ul>
              )}
              {importRelatorioFormato === "fintech" && (
                <ul className="text-xs text-emerald-700 space-y-1">
                  <li>• <strong>Id_Operation</strong>: Número do contrato</li>
                  <li>• <strong>Comissão</strong>: Valor da comissão recebida</li>
                  <li>• <strong>Data de Pagamento Comissão</strong>: Data do pagamento</li>
                  <li>• <strong>Cpf_Cliente</strong>: CPF do cliente</li>
                  <li>• <strong>Nome_Cliente</strong>: Nome do cliente</li>
                  <li>• <strong>Tipo_Produto</strong>: Tipo de produto</li>
                  <li>• <strong>Tabela_Contrato</strong>: Tabela de comissão</li>
                  <li>• <strong>Percentual_Comissao</strong>: Percentual</li>
                  <li>• <strong>Valor_Liberado</strong>: Valor do contrato</li>
                </ul>
              )}
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowImportarRelatorioBanco(false)}>Cancelar</Button>
            <Button 
              onClick={importarRelatorioBanco}
              disabled={importRelatorioLoading || !importRelatorioFile || (!importRelatorioBanco && importRelatorioFormato === "padrao")}
              className="bg-green-600 hover:bg-green-700"
            >
              {importRelatorioLoading ? (
                <><RotateCcw className="h-4 w-4 mr-2 animate-spin" />Importando...</>
              ) : (
                <><Upload className="h-4 w-4 mr-2" />Importar e Conciliar</>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Resultado da Importação */}
      <Dialog open={!!importRelatorioResultado} onOpenChange={() => setImportRelatorioResultado(null)}>
        <DialogContent className="max-w-[95vw] w-full max-h-[85vh]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileSpreadsheet className="h-5 w-5 text-green-600" />
              Resultado da Importação
            </DialogTitle>
            <DialogDescription>
              {importRelatorioResultado?.message}
            </DialogDescription>
          </DialogHeader>
          
          <ScrollArea className="max-h-[65vh]">
            <div className="space-y-4 pr-4">
              {importRelatorioResultado?.conciliados_detalhes?.length > 0 && (
                <div>
                  <h4 className="font-semibold text-sm text-green-800 mb-2 flex items-center gap-2">
                    <CheckCircle className="h-4 w-4" />
                    <>{"Conciliados (" + importRelatorioResultado.conciliados + ")"}<span className="ml-2 text-xs font-normal text-green-600">Recebimento baixado com sucesso</span></>
                  </h4>
                  <div className="border border-green-200 rounded-lg overflow-x-auto">
                    <Table>
                      <TableHeader>
                        <TableRow className="bg-green-50">
                          <TableHead className="text-[11px] font-semibold text-green-800 whitespace-nowrap">Contrato</TableHead>
                          <TableHead className="text-[11px] font-semibold text-green-800 whitespace-nowrap">CPF</TableHead>
                          <TableHead className="text-[11px] font-semibold text-green-800 whitespace-nowrap">Cliente</TableHead>
                          <TableHead className="text-[11px] font-semibold text-green-800 whitespace-nowrap">Banco</TableHead>
                          <TableHead className="text-[11px] font-semibold text-green-800 whitespace-nowrap">Produto</TableHead>
                          <TableHead className="text-[11px] font-semibold text-green-800 whitespace-nowrap">Convenio</TableHead>
                          <TableHead className="text-[11px] font-semibold text-green-800 whitespace-nowrap">Tabela</TableHead>
                          <TableHead className="text-[11px] font-semibold text-green-800 whitespace-nowrap text-right">Vlr. Contrato</TableHead>
                          <TableHead className="text-[11px] font-semibold text-green-800 whitespace-nowrap text-right">Comissao %</TableHead>
                          <TableHead className="text-[11px] font-semibold text-green-800 whitespace-nowrap text-right">Vlr. Comissao</TableHead>
                          <TableHead className="text-[11px] font-semibold text-green-800 whitespace-nowrap">Data Pgto</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {importRelatorioResultado.conciliados_detalhes.map((item, idx) => (
                          <TableRow key={idx} className="hover:bg-green-50/50">
                            <TableCell className="text-[11px] font-mono whitespace-nowrap">{item.contrato}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{item.cpf || "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap max-w-[180px] truncate">{item.cliente || "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{item.banco || "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{item.produto || "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{item.convenio || "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap max-w-[150px] truncate">{item.tabela || "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap text-right">{item.valor_contrato ? ("R$ " + Number(item.valor_contrato).toLocaleString("pt-BR", { minimumFractionDigits: 2 })) : "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap text-right">{item.comissao_pct ? (Number(item.comissao_pct * 100).toFixed(2) + "%") : "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap text-right font-semibold text-green-700">{"R$ " + Number(item.valor || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{item.data_pagamento ? String(item.data_pagamento).substring(0, 10) : "-"}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              )}


              {importRelatorioResultado?.ja_importados_detalhes?.length > 0 && (
                <div>
                  <h4 className="font-semibold text-sm text-yellow-800 mb-2 flex items-center gap-2">
                    <AlertCircle className="h-4 w-4" />
                    <>{"Ja Importados (" + importRelatorioResultado.ja_importados + ")"}<span className="ml-2 text-xs font-normal text-yellow-600">Recebimento ja processado anteriormente</span></>
                  </h4>
                  <div className="border border-yellow-200 rounded-lg overflow-x-auto">
                    <Table>
                      <TableHeader>
                        <TableRow className="bg-yellow-50">
                          <TableHead className="text-[11px] font-semibold text-yellow-800 whitespace-nowrap">Contrato</TableHead>
                          <TableHead className="text-[11px] font-semibold text-yellow-800 whitespace-nowrap">CPF</TableHead>
                          <TableHead className="text-[11px] font-semibold text-yellow-800 whitespace-nowrap">Cliente</TableHead>
                          <TableHead className="text-[11px] font-semibold text-yellow-800 whitespace-nowrap">Banco</TableHead>
                          <TableHead className="text-[11px] font-semibold text-yellow-800 whitespace-nowrap">Produto</TableHead>
                          <TableHead className="text-[11px] font-semibold text-yellow-800 whitespace-nowrap text-right">Vlr. Comissao</TableHead>
                          <TableHead className="text-[11px] font-semibold text-yellow-800 whitespace-nowrap">Status Atual</TableHead>
                          <TableHead className="text-[11px] font-semibold text-yellow-800 whitespace-nowrap text-right">Vlr. Anterior</TableHead>
                          <TableHead className="text-[11px] font-semibold text-yellow-800 whitespace-nowrap">Data Import. Anterior</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {importRelatorioResultado.ja_importados_detalhes.map((item, idx) => (
                          <TableRow key={idx} className="hover:bg-yellow-50/50">
                            <TableCell className="text-[11px] font-mono whitespace-nowrap">{item.contrato}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{item.cpf || "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap max-w-[180px] truncate">{item.cliente || "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{item.banco || "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{item.produto || "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap text-right font-medium text-yellow-700">{"R$ " + Number(item.valor || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap"><span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-yellow-100 text-yellow-800">{item.status_atual || "-"}</span></TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap text-right">{item.valor_recebido_anterior ? ("R$ " + Number(item.valor_recebido_anterior).toLocaleString("pt-BR", { minimumFractionDigits: 2 })) : "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{item.data_recebimento_anterior ? String(item.data_recebimento_anterior).substring(0, 10) : "-"}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              )}

              {importRelatorioResultado?.nao_encontrados_detalhes?.length > 0 && (
                <div>
                  <h4 className="font-semibold text-sm text-red-800 mb-2 flex items-center gap-2">
                    <XCircle className="h-4 w-4" />
                    <>{"Nao Encontrados (" + importRelatorioResultado.nao_encontrados + ")"}<span className="ml-2 text-xs font-normal text-red-600">Contrato nao localizado no sistema</span></>
                  </h4>
                  <div className="border border-red-200 rounded-lg overflow-x-auto">
                    <Table>
                      <TableHeader>
                        <TableRow className="bg-red-50">
                          <TableHead className="text-[11px] font-semibold text-red-800 whitespace-nowrap">Contrato</TableHead>
                          <TableHead className="text-[11px] font-semibold text-red-800 whitespace-nowrap">CPF</TableHead>
                          <TableHead className="text-[11px] font-semibold text-red-800 whitespace-nowrap">Cliente</TableHead>
                          <TableHead className="text-[11px] font-semibold text-red-800 whitespace-nowrap">Banco</TableHead>
                          <TableHead className="text-[11px] font-semibold text-red-800 whitespace-nowrap">Produto</TableHead>
                          <TableHead className="text-[11px] font-semibold text-red-800 whitespace-nowrap">Convenio</TableHead>
                          <TableHead className="text-[11px] font-semibold text-red-800 whitespace-nowrap">Tabela</TableHead>
                          <TableHead className="text-[11px] font-semibold text-red-800 whitespace-nowrap text-right">Vlr. Contrato</TableHead>
                          <TableHead className="text-[11px] font-semibold text-red-800 whitespace-nowrap text-right">Comissao %</TableHead>
                          <TableHead className="text-[11px] font-semibold text-red-800 whitespace-nowrap text-right">Vlr. Comissao</TableHead>
                          <TableHead className="text-[11px] font-semibold text-red-800 whitespace-nowrap">Motivo</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {importRelatorioResultado.nao_encontrados_detalhes.map((item, idx) => (
                          <TableRow key={idx} className="hover:bg-red-50/50">
                            <TableCell className="text-[11px] font-mono whitespace-nowrap">{typeof item === "string" ? item : item.contrato}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{typeof item === "string" ? "-" : (item.cpf || "-")}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap max-w-[180px] truncate">{typeof item === "string" ? "-" : (item.cliente || "-")}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{typeof item === "string" ? "-" : (item.banco || "-")}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{typeof item === "string" ? "-" : (item.produto || "-")}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap">{typeof item === "string" ? "-" : (item.convenio || "-")}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap max-w-[150px] truncate">{typeof item === "string" ? "-" : (item.tabela || "-")}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap text-right">{typeof item !== "string" && item.valor_contrato ? ("R$ " + Number(item.valor_contrato).toLocaleString("pt-BR", { minimumFractionDigits: 2 })) : "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap text-right">{typeof item !== "string" && item.comissao_pct ? (Number(item.comissao_pct * 100).toFixed(2) + "%") : "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap text-right">{typeof item !== "string" && item.valor ? ("R$ " + Number(item.valor).toLocaleString("pt-BR", { minimumFractionDigits: 2 })) : "-"}</TableCell>
                            <TableCell className="text-[11px] whitespace-nowrap text-red-600">{typeof item === "string" ? "Nao encontrado" : (item.motivo || "Nao encontrado")}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              )}

              {(!importRelatorioResultado?.conciliados_detalhes?.length && !importRelatorioResultado?.nao_encontrados_detalhes?.length) && (
                <p className="text-sm text-gray-500 text-center py-4">Nenhum registro processado</p>
              )}
            </div>
          </ScrollArea>
          
          <DialogFooter>
            <Button onClick={() => setImportRelatorioResultado(null)} className="bg-green-600 hover:bg-green-700">
              Fechar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Novo Lançamento */}
      <Dialog open={showNovoLancamento} onOpenChange={setShowNovoLancamento}>
        <DialogContent className="max-w-md" data-testid="modal-novo-lancamento">
          <DialogHeader>
            <DialogTitle>Novo Lançamento</DialogTitle>
            <DialogDescription>Registre um novo crédito ou débito</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div className="flex gap-2">
              <Button type="button" variant={novoLancamento.tipo === "CREDITO" ? "default" : "outline"}
                className={`flex-1 gap-1 ${novoLancamento.tipo === "CREDITO" ? "bg-green-600 hover:bg-green-700" : ""}`}
                onClick={() => setNovoLancamento({ ...novoLancamento, tipo: "CREDITO" })} data-testid="btn-tipo-credito">
                <ArrowUpRight className="h-4 w-4" /> Crédito
              </Button>
              <Button type="button" variant={novoLancamento.tipo === "DEBITO" ? "default" : "outline"}
                className={`flex-1 gap-1 ${novoLancamento.tipo === "DEBITO" ? "bg-red-600 hover:bg-red-700" : ""}`}
                onClick={() => setNovoLancamento({ ...novoLancamento, tipo: "DEBITO" })} data-testid="btn-tipo-debito">
                <ArrowDownLeft className="h-4 w-4" /> Débito
              </Button>
            </div>
            <div>
              <Label>Centro de Custo *</Label>
              <Select value={novoLancamento.conta_id} onValueChange={(v) => setNovoLancamento({ ...novoLancamento, conta_id: v })}>
                <SelectTrigger data-testid="select-conta-lancamento"><SelectValue placeholder="Selecione o centro de custo" /></SelectTrigger>
                <SelectContent>
                  {gestaoContas.map(c => (<SelectItem key={c.id} value={c.id}>{c.nome}</SelectItem>))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>Descrição *</Label>
              <Input value={novoLancamento.descricao} onChange={(e) => setNovoLancamento({ ...novoLancamento, descricao: e.target.value })} placeholder="Descreva o lançamento" data-testid="input-descricao-lancamento" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label>Valor (R$) *</Label>
                <Input type="number" step="0.01" value={novoLancamento.valor} onChange={(e) => setNovoLancamento({ ...novoLancamento, valor: e.target.value })} placeholder="0,00" data-testid="input-valor-lancamento" />
              </div>
              <div>
                <Label>Data *</Label>
                <Input type="date" value={novoLancamento.data} onChange={(e) => setNovoLancamento({ ...novoLancamento, data: e.target.value })} data-testid="input-data-lancamento" />
              </div>
            </div>
            <div>
              <div className="flex items-center justify-between">
                <Label>Conta</Label>
              </div>
              <Select value={novoLancamento.categoria} onValueChange={(v) => setNovoLancamento({ ...novoLancamento, categoria: v })}>
                <SelectTrigger data-testid="select-categoria-lancamento"><SelectValue placeholder="Selecione a conta" /></SelectTrigger>
                <SelectContent>
                  {categoriasGestao.map(cat => (<SelectItem key={cat.id} value={cat.nome}>{cat.nome}</SelectItem>))}
                </SelectContent>
              </Select>
              <div className="flex gap-2 mt-2">
                <Input value={novaCategoriaNome} onChange={(e) => setNovaCategoriaNome(e.target.value)} placeholder="Nova conta..." className="h-8 text-sm" data-testid="input-nova-categoria" />
                <Button type="button" size="sm" variant="outline" onClick={adicionarCategoria} data-testid="btn-add-categoria">Adicionar</Button>
              </div>
              {categoriasGestao.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-2 max-h-20 overflow-y-auto">
                  {categoriasGestao.map(cat => (
                    <span key={cat.id} className="inline-flex items-center gap-1 text-xs bg-gray-100 rounded px-2 py-0.5">
                      {cat.nome}
                      <button type="button" className="text-red-500 hover:text-red-700" onClick={() => excluirCategoria(cat.id)} data-testid={`btn-del-categoria-${cat.id}`}>×</button>
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div>
              <Label>Tipo de cobrança</Label>
              <div className="flex gap-2 mt-1">
                <Button type="button" variant={novoLancamento.tipo_cobranca === "unica" ? "default" : "outline"} className="flex-1" onClick={() => setNovoLancamento({ ...novoLancamento, tipo_cobranca: "unica", parcelas: 1 })} data-testid="btn-cobranca-unica">Única</Button>
                <Button type="button" variant={novoLancamento.tipo_cobranca === "mensal" ? "default" : "outline"} className="flex-1" onClick={() => setNovoLancamento({ ...novoLancamento, tipo_cobranca: "mensal" })} data-testid="btn-cobranca-mensal">Mensal</Button>
              </div>
            </div>
            {novoLancamento.tipo_cobranca === "mensal" && (
              <div>
                <Label>Período (quantidade de parcelas / meses)</Label>
                <Input type="number" min="1" max="120" value={novoLancamento.parcelas} onChange={(e) => setNovoLancamento({ ...novoLancamento, parcelas: e.target.value })} placeholder="Ex: 12" data-testid="input-parcelas-lancamento" />
                <p className="text-xs text-gray-500 mt-1">Serão criados {parseInt(novoLancamento.parcelas) || 1} lançamentos, um a cada mês.</p>
              </div>
            )}
            <label className="flex items-center gap-2 text-sm cursor-pointer select-none" data-testid="check-baixar-auto">
              <input type="checkbox" className="h-4 w-4 accent-blue-600" checked={novoLancamento.baixar_auto} onChange={(e) => setNovoLancamento({ ...novoLancamento, baixar_auto: e.target.checked })} />
              <span className="text-gray-700"><strong>Ação Extra:</strong> Baixar lançamento cadastrado automaticamente</span>
            </label>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowNovoLancamento(false)}>Cancelar</Button>
            <Button onClick={salvarLancamento} className={novoLancamento.tipo === "CREDITO" ? "bg-green-600 hover:bg-green-700" : "bg-red-600 hover:bg-red-700"} data-testid="btn-salvar-lancamento">
              Salvar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Nova Conta */}
      <Dialog open={showNovaConta} onOpenChange={setShowNovaConta}>
        <DialogContent className="max-w-md" data-testid="modal-nova-conta">
          <DialogHeader>
            <DialogTitle>Nova Conta</DialogTitle>
            <DialogDescription>Cadastre uma nova conta para lançamentos</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div>
              <Label>Nome da Conta *</Label>
              <Input value={novaConta.nome} onChange={(e) => setNovaConta({ ...novaConta, nome: e.target.value })} placeholder="Ex: Caixa, Banco Bradesco, Fornecedores" data-testid="input-nome-conta" />
            </div>
            <div>
              <Label>Tipo</Label>
              <Select value={novaConta.tipo} onValueChange={(v) => setNovaConta({ ...novaConta, tipo: v })}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="ATIVO">Ativo</SelectItem>
                  <SelectItem value="PASSIVO">Passivo</SelectItem>
                  <SelectItem value="RECEITA">Receita</SelectItem>
                  <SelectItem value="DESPESA">Despesa</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>Categoria</Label>
              <Input value={novaConta.categoria} onChange={(e) => setNovaConta({ ...novaConta, categoria: e.target.value })} placeholder="Ex: Banco, Caixa, Fornecedor" />
            </div>
            <div>
              <Label>Saldo Inicial (R$)</Label>
              <Input type="number" step="0.01" value={novaConta.saldo_inicial} onChange={(e) => setNovaConta({ ...novaConta, saldo_inicial: e.target.value })} placeholder="0,00" data-testid="input-saldo-inicial" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowNovaConta(false)}>Cancelar</Button>
            <Button onClick={salvarConta} className="bg-blue-600 hover:bg-blue-700" data-testid="btn-salvar-conta">Salvar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Detalhamento Despesas */}
      <Dialog open={showDespesasDetalhe} onOpenChange={setShowDespesasDetalhe}>
        <DialogContent data-testid="despesas-detalhe">
          <DialogHeader>
            <DialogTitle>Detalhamento de Despesas</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-muted-foreground">Composição do total de {formatCurrency(resumo.despesa_total || 0)} no período selecionado.</p>
          <div className="space-y-2 py-2">
            {(() => {
              const itens = [
                ["Comissão Atendente", resumo.despesa_atendente || 0],
                ["Comissão Corretor", resumo.despesa_corretor || 0],
                ["Comissão Ger./Adm", resumo.despesa_ger_adm || 0],
                ["Impostos", resumo.despesa_impostos || 0],
              ];
              const somaComissoes = itens.reduce((a, [, v]) => a + v, 0);
              const outras = (resumo.despesa_total || 0) - somaComissoes;
              if (outras > 0.009) itens.push(["Outras despesas", outras]);
              return itens.map(([label, val]) => (
                <div key={label} className="flex items-center justify-between border-b pb-1.5">
                  <span className="text-sm text-gray-600">{label}</span>
                  <span className="text-sm font-semibold text-red-600">{formatCurrency(val)}</span>
                </div>
              ));
            })()}
            <div className="flex items-center justify-between pt-2">
              <span className="text-sm font-bold">Total Despesas</span>
              <span className="text-base font-bold text-red-700">{formatCurrency(resumo.despesa_total || 0)}</span>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Dar Baixa */}
      <Dialog open={!!showBaixa} onOpenChange={() => setShowBaixa(null)}>
        <DialogContent className="max-w-md" data-testid="modal-baixa">
          <DialogHeader>
            <DialogTitle>Dar Baixa no Lançamento</DialogTitle>
            <DialogDescription>
              {showBaixa && <><strong>{showBaixa.descricao}</strong> - {formatCurrency(showBaixa.valor)}</>}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div>
              <Label>Data da Baixa *</Label>
              <Input type="date" value={baixaData.data_baixa} onChange={(e) => setBaixaData({ ...baixaData, data_baixa: e.target.value })} data-testid="input-data-baixa" />
            </div>
            <div>
              <Label>Forma de Pagamento</Label>
              <Select value={baixaData.forma_pagamento} onValueChange={(v) => setBaixaData({ ...baixaData, forma_pagamento: v })}>
                <SelectTrigger data-testid="select-forma-pagamento"><SelectValue placeholder="Selecione" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="Dinheiro">Dinheiro</SelectItem>
                  <SelectItem value="PIX">PIX</SelectItem>
                  <SelectItem value="Transferência">Transferência</SelectItem>
                  <SelectItem value="Boleto">Boleto</SelectItem>
                  <SelectItem value="Cartão">Cartão</SelectItem>
                  <SelectItem value="Cheque">Cheque</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>Observação</Label>
              <Input value={baixaData.observacao} onChange={(e) => setBaixaData({ ...baixaData, observacao: e.target.value })} placeholder="Observação da baixa (opcional)" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowBaixa(null)}>Cancelar</Button>
            <Button onClick={() => baixarLancamento(showBaixa?.id)} className="bg-green-600 hover:bg-green-700" data-testid="btn-confirmar-baixa">
              Confirmar Baixa
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Estorno */}
      <Dialog open={!!showEstorno} onOpenChange={() => setShowEstorno(null)}>
        <DialogContent className="max-w-md" data-testid="modal-estorno">
          <DialogHeader>
            <DialogTitle>Estornar Lançamento</DialogTitle>
            <DialogDescription>
              {showEstorno && <><strong>{showEstorno.descricao}</strong> - {formatCurrency(showEstorno.valor)}</>}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div>
              <Label>Motivo do Estorno *</Label>
              <Input value={estornoMotivo} onChange={(e) => setEstornoMotivo(e.target.value)} placeholder="Informe o motivo do estorno" data-testid="input-motivo-estorno" />
            </div>
            <div className="p-3 bg-orange-50 border border-orange-200 rounded-lg">
              <p className="text-sm text-orange-700">
                <AlertCircle className="h-4 w-4 inline mr-1" />
                O estorno é irreversível. O lançamento ficará marcado como ESTORNADO e não será contabilizado no saldo.
              </p>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowEstorno(null)}>Cancelar</Button>
            <Button onClick={() => estornarLancamento(showEstorno?.id)} className="bg-orange-600 hover:bg-orange-700" data-testid="btn-confirmar-estorno">
              Confirmar Estorno
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
